/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-record-edit.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/common/src/pipes/date_pipe';
import * as import5 from '@angular/core/src/linker/view_utils';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/change_detection';
import * as import9 from '@angular/core/src/i18n/tokens';
import * as import10 from '../shared/config.service';
import * as import11 from '../shared/intl.service';
import * as import12 from '../shared/meta.service';
import * as import13 from '@angular/core/src/linker/element_ref';
import * as import14 from '../shared/search.service';
import * as import15 from '../shared/utils.service';
import * as import16 from '@angular/forms/src/form_builder';
import * as import17 from '@angular/router/src/router';
import * as import18 from '../shared/content.service';
import * as import19 from '@angular/router/src/router_state';
import * as import20 from '@angular/core/src/metadata/view';
import * as import21 from '@angular/core/src/linker/component_factory';
import * as import22 from '../../../node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import23 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import24 from '@angular/common/src/pipes/uppercase_pipe';
import * as import25 from '@angular/core/src/linker/template_ref';
import * as import26 from '@angular/common/src/directives/ng_switch';
import * as import27 from '@angular/common/src/directives/ng_if';
import * as import28 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_group_directive.ngfactory';
import * as import29 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import30 from '../../../node_modules/@angular/forms/src/directives/checkbox_value_accessor.ngfactory';
import * as import31 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_control_name.ngfactory';
import * as import32 from '../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import33 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_group_name.ngfactory';
import * as import34 from './image-upload.component.ngfactory';
import * as import35 from '../../../node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import36 from '../../../node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import37 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import38 from '../shared/data.service';
import * as import39 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import40 from '@angular/forms/src/directives/checkbox_value_accessor';
import * as import41 from '@angular/forms/src/directives/control_value_accessor';
import * as import42 from '@angular/forms/src/directives/reactive_directives/form_control_name';
import * as import43 from '@angular/forms/src/directives/ng_control';
import * as import44 from '@angular/forms/src/directives/ng_control_status';
import * as import45 from '@angular/forms/src/directives/default_value_accessor';
import * as import46 from './image-upload.component';
import * as import47 from '@angular/forms/src/directives/reactive_directives/form_group_name';
import * as import48 from '@angular/forms/src/directives/control_container';
import * as import49 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import50 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import51 from '@angular/common/src/directives/ng_for';
import * as import52 from '@angular/forms/src/directives/reactive_directives/form_group_directive';
import * as import53 from '../shared/search-autocomplete.component.ngfactory';
import * as import54 from '../shared/search-autocomplete.component';
import * as import55 from './html-editor.component.ngfactory';
import * as import56 from './html-editor.component';
export class Wrapper_ContentRecordEditComponent {
  context:import0.ContentRecordEditComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any,p10:any) {
    this.changed = false;
    this.context = new import0.ContentRecordEditComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,p10);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentRecordEditComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentRecordEditComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _DatePipe_0_4:import4.DatePipe;
  _ContentRecordEditComponent_0_5:Wrapper_ContentRecordEditComponent;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent_Host0,renderType_ContentRecordEditComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer,'ng-component',import5.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentRecordEditComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._DatePipe_0_4 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
    this._ContentRecordEditComponent_0_5 = new Wrapper_ContentRecordEditComponent(this.parentInjector.get(import10.ConfigService),this.parentInjector.get(import11.IntlService),this.parentInjector.get(import12.MetaService),new import13.ElementRef(this._el_0),this.parentInjector.get(import14.SearchService),this._DatePipe_0_4,this.parentInjector.get(import15.UtilsService),this.parentInjector.get(import16.FormBuilder),this.parentInjector.get(import17.Router),this.parentInjector.get(import18.ContentService),this.parentInjector.get(import19.ActivatedRoute));
    this._appEl_0.initComponent(this._ContentRecordEditComponent_0_5.context,([] as any[]),compView_0);
    compView_0.create(this._ContentRecordEditComponent_0_5.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import4.DatePipe) && (0 === requestNodeIndex))) { return this._DatePipe_0_4; }
    if (((token === import0.ContentRecordEditComponent) && (0 === requestNodeIndex))) { return this._ContentRecordEditComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentRecordEditComponent_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._ContentRecordEditComponent_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordEditComponent_Host0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentRecordEditComponent_Host === (null as any))) { (renderType_ContentRecordEditComponent_Host = viewUtils.createRenderComponentType('',0,import20.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentRecordEditComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentRecordEditComponentNgFactory:import21.ComponentFactory<import0.ContentRecordEditComponent> = new import21.ComponentFactory<import0.ContentRecordEditComponent>('ng-component',viewFactory_ContentRecordEditComponent_Host0,import0.ContentRecordEditComponent);
const styles_ContentRecordEditComponent:any[] = ([] as any[]);
var renderType_ContentRecordEditComponent:import2.RenderComponentType = (null as any);
class _View_ContentRecordEditComponent0 extends import1.AppView<import0.ContentRecordEditComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgSwitch_2_3:import22.Wrapper_NgSwitch;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _appEl_4:import3.AppElement;
  _TemplateRef_4_5:any;
  _NgSwitchCase_4_6:import22.Wrapper_NgSwitchCase;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _appEl_6:import3.AppElement;
  _TemplateRef_6_5:any;
  _NgSwitchCase_6_6:import22.Wrapper_NgSwitchCase;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _appEl_8:import3.AppElement;
  _TemplateRef_8_5:any;
  _NgIf_8_6:import23.Wrapper_NgIf;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _appEl_10:import3.AppElement;
  _TemplateRef_10_5:any;
  _NgSwitchCase_10_6:import22.Wrapper_NgSwitchCase;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _el_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _anchor_22:any;
  /*private*/ _appEl_22:import3.AppElement;
  _TemplateRef_22_5:any;
  _NgIf_22_6:import23.Wrapper_NgIf;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _pipe_date_0:import4.DatePipe;
  _pipe_uppercase_1:import24.UpperCasePipe;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent0,renderType_ContentRecordEditComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','content-header'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n	',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'h1',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSwitch_2_3 = new import22.Wrapper_NgSwitch();
    this._text_3 = this.renderer.createText(this._el_2,'\n  		',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_4 = new import3.AppElement(4,2,this,this._anchor_4);
    this._TemplateRef_4_5 = new import25.TemplateRef_(this._appEl_4,viewFactory_ContentRecordEditComponent1);
    this._NgSwitchCase_4_6 = new import22.Wrapper_NgSwitchCase(this._appEl_4.vcRef,this._TemplateRef_4_5,this._NgSwitch_2_3.context);
    this._text_5 = this.renderer.createText(this._el_2,'\n      ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_6 = new import3.AppElement(6,2,this,this._anchor_6);
    this._TemplateRef_6_5 = new import25.TemplateRef_(this._appEl_6,viewFactory_ContentRecordEditComponent2);
    this._NgSwitchCase_6_6 = new import22.Wrapper_NgSwitchCase(this._appEl_6.vcRef,this._TemplateRef_6_5,this._NgSwitch_2_3.context);
    this._text_7 = this.renderer.createText(this._el_2,'\n      ',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_8 = new import3.AppElement(8,2,this,this._anchor_8);
    this._TemplateRef_8_5 = new import25.TemplateRef_(this._appEl_8,viewFactory_ContentRecordEditComponent3);
    this._NgIf_8_6 = new import23.Wrapper_NgIf(this._appEl_8.vcRef,this._TemplateRef_8_5);
    this._text_9 = this.renderer.createText(this._el_2,'\n      ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_10 = new import3.AppElement(10,2,this,this._anchor_10);
    this._TemplateRef_10_5 = new import25.TemplateRef_(this._appEl_10,viewFactory_ContentRecordEditComponent4);
    this._NgSwitchCase_10_6 = new import22.Wrapper_NgSwitchCase(this._appEl_10.vcRef,this._TemplateRef_10_5,this._NgSwitch_2_3.context);
    this._text_11 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_13 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_14 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','content'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n  \n  ',(null as any));
    this._el_16 = import5.createRenderElement(this.renderer,this._el_14,'div',new import5.InlineArray2(2,'class','row'),(null as any));
    this._el_17 = import5.createRenderElement(this.renderer,this._el_16,'div',new import5.InlineArray2(2,'class','col-xs-12'),(null as any));
    this._el_18 = import5.createRenderElement(this.renderer,this._el_17,'div',new import5.InlineArray2(2,'class','box'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n    ',(null as any));
    this._el_20 = import5.createRenderElement(this.renderer,this._el_18,'div',new import5.InlineArray2(2,'class','box-body'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n\n    ',(null as any));
    this._anchor_22 = this.renderer.createTemplateAnchor(this._el_20,(null as any));
    this._appEl_22 = new import3.AppElement(22,20,this,this._anchor_22);
    this._TemplateRef_22_5 = new import25.TemplateRef_(this._appEl_22,viewFactory_ContentRecordEditComponent5);
    this._NgIf_22_6 = new import23.Wrapper_NgIf(this._appEl_22.vcRef,this._TemplateRef_22_5);
    this._text_23 = this.renderer.createText(this._el_20,'  \n\n\n    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_18,'\n  ',(null as any));
    this._text_25 = this.renderer.createText(this._el_14,'\n',(null as any));
    this._pipe_date_0 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
    this._pipe_uppercase_1 = new import24.UpperCasePipe();
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._anchor_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._anchor_8,
      this._text_9,
      this._anchor_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._el_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._anchor_22,
      this._text_23,
      this._text_24,
      this._text_25
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import26.NgSwitchCase) && (4 === requestNodeIndex))) { return this._NgSwitchCase_4_6.context; }
    if (((token === import25.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import26.NgSwitchCase) && (6 === requestNodeIndex))) { return this._NgSwitchCase_6_6.context; }
    if (((token === import25.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import27.NgIf) && (8 === requestNodeIndex))) { return this._NgIf_8_6.context; }
    if (((token === import25.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import26.NgSwitchCase) && (10 === requestNodeIndex))) { return this._NgSwitchCase_10_6.context; }
    if (((token === import26.NgSwitch) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 11)))) { return this._NgSwitch_2_3.context; }
    if (((token === import25.TemplateRef) && (22 === requestNodeIndex))) { return this._TemplateRef_22_5; }
    if (((token === import27.NgIf) && (22 === requestNodeIndex))) { return this._NgIf_22_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.context.action;
    this._NgSwitch_2_3.check_ngSwitch(currVal_2_0_0,throwOnChange,false);
    this._NgSwitch_2_3.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_4_0_0:any = 'add';
    this._NgSwitchCase_4_6.check_ngSwitchCase(currVal_4_0_0,throwOnChange,false);
    this._NgSwitchCase_4_6.detectChangesInInputProps(this,this._anchor_4,throwOnChange);
    const currVal_6_0_0:any = 'update';
    this._NgSwitchCase_6_6.check_ngSwitchCase(currVal_6_0_0,throwOnChange,false);
    this._NgSwitchCase_6_6.detectChangesInInputProps(this,this._anchor_6,throwOnChange);
    const currVal_8_0_0:any = (this.context.content && (this.context.action == 'update'));
    this._NgIf_8_6.check_ngIf(currVal_8_0_0,throwOnChange,false);
    this._NgIf_8_6.detectChangesInInputProps(this,this._anchor_8,throwOnChange);
    const currVal_10_0_0:any = 'update';
    this._NgSwitchCase_10_6.check_ngSwitchCase(currVal_10_0_0,throwOnChange,false);
    this._NgSwitchCase_10_6.detectChangesInInputProps(this,this._anchor_10,throwOnChange);
    const currVal_22_0_0:any = (this.context.content || (this.context.action == 'add'));
    this._NgIf_22_6.check_ngIf(currVal_22_0_0,throwOnChange,false);
    this._NgIf_22_6.detectChangesInInputProps(this,this._anchor_22,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgSwitch_2_3.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_ContentRecordEditComponent0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentRecordEditComponent> {
  if ((renderType_ContentRecordEditComponent === (null as any))) { (renderType_ContentRecordEditComponent = viewUtils.createRenderComponentType('',0,import20.ViewEncapsulation.None,styles_ContentRecordEditComponent,{})); }
  return new _View_ContentRecordEditComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent1,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'Nouveau disque',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_ContentRecordEditComponent1(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent2,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'Edition ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_4:any = import5.interpolate(1,'',((this.parent.context.content == (null as any))? (null as any): this.parent.context.content.cid),'');
    if (import5.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordEditComponent2(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent3,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'a',new import5.InlineArray2(2,'class','lLink'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','btn btn-default btn-sm'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'Supprimer',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n      ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.deleteContent('record',this.parent.context.content._id)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentRecordEditComponent3(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_date_0_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent4,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,' ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._pipe_date_0_0 = import5.pureProxy2((<_View_ContentRecordEditComponent0>this.parent)._pipe_date_0.transform.bind((<_View_ContentRecordEditComponent0>this.parent)._pipe_date_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import5.interpolate(1,'(modifié: ',valUnwrapper.unwrap(import5.castByValue(this._pipe_date_0_0,(<_View_ContentRecordEditComponent0>this.parent)._pipe_date_0.transform)(((this.parent.context.content == (null as any))? (null as any): this.parent.context.content.update_date),'dd MM yyyy')),')');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordEditComponent4(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent5 extends import1.AppView<any> {
  _el_0:any;
  _FormGroupDirective_0_3:import28.Wrapper_FormGroupDirective;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import29.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _CheckboxControlValueAccessor_11_3:import30.Wrapper_CheckboxControlValueAccessor;
  _NG_VALUE_ACCESSOR_11_4:any[];
  _FormControlName_11_5:import31.Wrapper_FormControlName;
  _NgControl_11_6:any;
  _NgControlStatus_11_7:import29.Wrapper_NgControlStatus;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  _DefaultValueAccessor_18_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_18_4:any[];
  _FormControlName_18_5:import31.Wrapper_FormControlName;
  _NgControl_18_6:any;
  _NgControlStatus_18_7:import29.Wrapper_NgControlStatus;
  _text_19:any;
  _text_20:any;
  _anchor_21:any;
  /*private*/ _appEl_21:import3.AppElement;
  _TemplateRef_21_5:any;
  _NgIf_21_6:import23.Wrapper_NgIf;
  _text_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _el_29:any;
  _FormGroupName_29_3:import33.Wrapper_FormGroupName;
  _ControlContainer_29_4:any;
  _NgControlStatusGroup_29_5:import29.Wrapper_NgControlStatusGroup;
  _text_30:any;
  _el_31:any;
  /*private*/ _appEl_31:import3.AppElement;
  _ImageUploadComponent_31_4:import34.Wrapper_ImageUploadComponent;
  _text_32:any;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _text_38:any;
  _el_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _el_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _el_47:any;
  _SelectControlValueAccessor_47_3:import35.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_47_4:any[];
  _FormControlName_47_5:import31.Wrapper_FormControlName;
  _NgControl_47_6:any;
  _NgControlStatus_47_7:import29.Wrapper_NgControlStatus;
  _text_48:any;
  _el_49:any;
  _NgSelectOption_49_3:import35.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_49_4:import36.Wrapper_NgSelectMultipleOption;
  _text_50:any;
  _text_51:any;
  _el_52:any;
  _NgSelectOption_52_3:import35.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_52_4:import36.Wrapper_NgSelectMultipleOption;
  _text_53:any;
  _text_54:any;
  _text_55:any;
  _text_56:any;
  _el_57:any;
  _text_58:any;
  _el_59:any;
  _el_60:any;
  _text_61:any;
  _el_62:any;
  _DefaultValueAccessor_62_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_62_4:any[];
  _FormControlName_62_5:import31.Wrapper_FormControlName;
  _NgControl_62_6:any;
  _NgControlStatus_62_7:import29.Wrapper_NgControlStatus;
  _text_63:any;
  _text_64:any;
  _el_65:any;
  _text_66:any;
  _el_67:any;
  _el_68:any;
  _text_69:any;
  _el_70:any;
  _DefaultValueAccessor_70_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_70_4:any[];
  _FormControlName_70_5:import31.Wrapper_FormControlName;
  _NgControl_70_6:any;
  _NgControlStatus_70_7:import29.Wrapper_NgControlStatus;
  _text_71:any;
  _text_72:any;
  _text_73:any;
  _el_74:any;
  _text_75:any;
  _el_76:any;
  _text_77:any;
  _el_78:any;
  _el_79:any;
  _text_80:any;
  _el_81:any;
  _DefaultValueAccessor_81_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_81_4:any[];
  _FormControlName_81_5:import31.Wrapper_FormControlName;
  _NgControl_81_6:any;
  _NgControlStatus_81_7:import29.Wrapper_NgControlStatus;
  _text_82:any;
  _text_83:any;
  _el_84:any;
  _text_85:any;
  _el_86:any;
  _el_87:any;
  _text_88:any;
  _el_89:any;
  _DefaultValueAccessor_89_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_89_4:any[];
  _FormControlName_89_5:import31.Wrapper_FormControlName;
  _NgControl_89_6:any;
  _NgControlStatus_89_7:import29.Wrapper_NgControlStatus;
  _text_90:any;
  _text_91:any;
  _el_92:any;
  _text_93:any;
  _el_94:any;
  _el_95:any;
  _text_96:any;
  _el_97:any;
  _DefaultValueAccessor_97_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_97_4:any[];
  _FormControlName_97_5:import31.Wrapper_FormControlName;
  _NgControl_97_6:any;
  _NgControlStatus_97_7:import29.Wrapper_NgControlStatus;
  _text_98:any;
  _text_99:any;
  _text_100:any;
  _el_101:any;
  _text_102:any;
  _anchor_103:any;
  /*private*/ _appEl_103:import3.AppElement;
  _TemplateRef_103_5:any;
  _NgFor_103_6:import37.Wrapper_NgFor;
  _text_104:any;
  _text_105:any;
  _anchor_106:any;
  /*private*/ _appEl_106:import3.AppElement;
  _TemplateRef_106_5:any;
  _NgIf_106_6:import23.Wrapper_NgIf;
  _text_107:any;
  _text_108:any;
  _text_109:any;
  _el_110:any;
  _text_111:any;
  _text_112:any;
  _el_113:any;
  _FormArrayName_113_3:import33.Wrapper_FormArrayName;
  _ControlContainer_113_4:any;
  _NgControlStatusGroup_113_5:import29.Wrapper_NgControlStatusGroup;
  _text_114:any;
  _anchor_115:any;
  /*private*/ _appEl_115:import3.AppElement;
  _TemplateRef_115_5:any;
  _NgFor_115_6:import37.Wrapper_NgFor;
  _text_116:any;
  _anchor_117:any;
  /*private*/ _appEl_117:import3.AppElement;
  _TemplateRef_117_5:any;
  _NgIf_117_6:import23.Wrapper_NgIf;
  _text_118:any;
  _text_119:any;
  _el_120:any;
  _text_121:any;
  _text_122:any;
  _el_123:any;
  _text_124:any;
  _el_125:any;
  _FormGroupName_125_3:import33.Wrapper_FormGroupName;
  _ControlContainer_125_4:any;
  _NgControlStatusGroup_125_5:import29.Wrapper_NgControlStatusGroup;
  _text_126:any;
  _anchor_127:any;
  /*private*/ _appEl_127:import3.AppElement;
  _TemplateRef_127_5:any;
  _NgFor_127_6:import37.Wrapper_NgFor;
  _text_128:any;
  _text_129:any;
  _text_130:any;
  _el_131:any;
  _text_132:any;
  _text_133:any;
  _el_134:any;
  _FormArrayName_134_3:import33.Wrapper_FormArrayName;
  _ControlContainer_134_4:any;
  _NgControlStatusGroup_134_5:import29.Wrapper_NgControlStatusGroup;
  _text_135:any;
  _el_136:any;
  _text_137:any;
  _anchor_138:any;
  /*private*/ _appEl_138:import3.AppElement;
  _TemplateRef_138_5:any;
  _NgFor_138_6:import37.Wrapper_NgFor;
  _text_139:any;
  _anchor_140:any;
  /*private*/ _appEl_140:import3.AppElement;
  _TemplateRef_140_5:any;
  _NgIf_140_6:import23.Wrapper_NgIf;
  _text_141:any;
  _text_142:any;
  _text_143:any;
  _el_144:any;
  _text_145:any;
  _el_146:any;
  _text_147:any;
  _el_148:any;
  _text_149:any;
  _el_150:any;
  _text_151:any;
  _text_152:any;
  _text_153:any;
  _text_154:any;
  _text_155:any;
  /*private*/ _expr_241:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent5,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_241 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'form',new import5.InlineArray2(2,'autocomplete','off'),(null as any));
    this._FormGroupDirective_0_3 = new import28.Wrapper_FormGroupDirective((null as any),(null as any));
    this._ControlContainer_0_4 = this._FormGroupDirective_0_3.context;
    this._NgControlStatusGroup_0_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n\n      ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','panel panel-default'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n\n			',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'Titre',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n			',(null as any));
    this._el_7 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n        ',(null as any));
    this._el_9 = import5.createRenderElement(this.renderer,this._el_7,'div',new import5.InlineArray2(2,'class','col-xs-1 switch material-switch'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n          ',(null as any));
    this._el_11 = import5.createRenderElement(this.renderer,this._el_9,'input',new import5.InlineArray8(8,'formControlName','active','id','act','name','act','type','checkbox'),(null as any));
    this._CheckboxControlValueAccessor_11_3 = new import30.Wrapper_CheckboxControlValueAccessor(this.renderer,new import13.ElementRef(this._el_11));
    this._NG_VALUE_ACCESSOR_11_4 = [this._CheckboxControlValueAccessor_11_3.context];
    this._FormControlName_11_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_11_4);
    this._NgControl_11_6 = this._FormControlName_11_5.context;
    this._NgControlStatus_11_7 = new import29.Wrapper_NgControlStatus(this._NgControl_11_6);
    this._text_12 = this.renderer.createText(this._el_9,'\n          ',(null as any));
    this._el_13 = import5.createRenderElement(this.renderer,this._el_9,'label',new import5.InlineArray4(4,'class','label-primary','for','act'),(null as any));
    this._text_14 = this.renderer.createText(this._el_9,'\n        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_7,'\n        ',(null as any));
    this._el_16 = import5.createRenderElement(this.renderer,this._el_7,'div',new import5.InlineArray2(2,'class','col-xs-9'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n          ',(null as any));
    this._el_18 = import5.createRenderElement(this.renderer,this._el_16,'input',new import5.InlineArray8(8,'class','form-control','formControlName','title','style','font-weight:bold','type','text'),(null as any));
    this._DefaultValueAccessor_18_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_18));
    this._NG_VALUE_ACCESSOR_18_4 = [this._DefaultValueAccessor_18_3.context];
    this._FormControlName_18_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_18_4);
    this._NgControl_18_6 = this._FormControlName_18_5.context;
    this._NgControlStatus_18_7 = new import29.Wrapper_NgControlStatus(this._NgControl_18_6);
    this._text_19 = this.renderer.createText(this._el_16,'\n        ',(null as any));
    this._text_20 = this.renderer.createText(this._el_7,' \n        ',(null as any));
    this._anchor_21 = this.renderer.createTemplateAnchor(this._el_7,(null as any));
    this._appEl_21 = new import3.AppElement(21,7,this,this._anchor_21);
    this._TemplateRef_21_5 = new import25.TemplateRef_(this._appEl_21,viewFactory_ContentRecordEditComponent6);
    this._NgIf_21_6 = new import23.Wrapper_NgIf(this._appEl_21.vcRef,this._TemplateRef_21_5);
    this._text_22 = this.renderer.createText(this._el_7,'\n      ',(null as any));
    this._text_23 = this.renderer.createText(this._el_2,'\n\n			 ',(null as any));
    this._el_24 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'Pochette',(null as any));
    this._text_26 = this.renderer.createText(this._el_2,'\n			',(null as any));
    this._el_27 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body panel-body-edit-image'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'\n        ',(null as any));
    this._el_29 = import5.createRenderElement(this.renderer,this._el_27,'div',new import5.InlineArray2(2,'formGroupName','cover'),(null as any));
    this._FormGroupName_29_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_29_4 = this._FormGroupName_29_3.context;
    this._NgControlStatusGroup_29_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_29_4);
    this._text_30 = this.renderer.createText(this._el_29,'\n          ',(null as any));
    this._el_31 = import5.createRenderElement(this.renderer,this._el_29,'image-uploads',new import5.InlineArray16(10,'addApi','/api/data/covers/add','deleteApi','/api/data/covers/delete/','deleteDir','covers','groupName','cover','imagePath','/data/covers/'),(null as any));
    this._appEl_31 = new import3.AppElement(31,29,this,this._el_31);
    var compView_31:any = import34.viewFactory_ImageUploadComponent0(this.viewUtils,this.injector(31),this._appEl_31);
    this._ImageUploadComponent_31_4 = new import34.Wrapper_ImageUploadComponent(this.parent.parentInjector.get(import38.DataService));
    this._appEl_31.initComponent(this._ImageUploadComponent_31_4.context,([] as any[]),compView_31);
    this._text_32 = this.renderer.createText((null as any),'\n          ',(null as any));
    compView_31.create(this._ImageUploadComponent_31_4.context,([] as any[]),(null as any));
    this._text_33 = this.renderer.createText(this._el_29,'\n        ',(null as any));
    this._text_34 = this.renderer.createText(this._el_27,'\n      ',(null as any));
    this._text_35 = this.renderer.createText(this._el_2,' \n\n			',(null as any));
    this._el_36 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'Métadonnées',(null as any));
    this._text_38 = this.renderer.createText(this._el_2,'\n			',(null as any));
    this._el_39 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_40 = this.renderer.createText(this._el_39,'\n        ',(null as any));
    this._el_41 = import5.createRenderElement(this.renderer,this._el_39,'div',new import5.InlineArray2(2,'class','form-group'),(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'\n          ',(null as any));
    this._el_43 = import5.createRenderElement(this.renderer,this._el_41,'div',new import5.InlineArray2(2,'class','block form-inline'),(null as any));
    this._text_44 = this.renderer.createText(this._el_43,'\n            ',(null as any));
    this._el_45 = import5.createRenderElement(this.renderer,this._el_43,'div',new import5.InlineArray2(2,'class','input-group col-md-3'),(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'\n              ',(null as any));
    this._el_47 = import5.createRenderElement(this.renderer,this._el_45,'select',new import5.InlineArray4(4,'class','form-control','formControlName','type'),(null as any));
    this._SelectControlValueAccessor_47_3 = new import35.Wrapper_SelectControlValueAccessor(this.renderer,new import13.ElementRef(this._el_47));
    this._NG_VALUE_ACCESSOR_47_4 = [this._SelectControlValueAccessor_47_3.context];
    this._FormControlName_47_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_47_4);
    this._NgControl_47_6 = this._FormControlName_47_5.context;
    this._NgControlStatus_47_7 = new import29.Wrapper_NgControlStatus(this._NgControl_47_6);
    this._text_48 = this.renderer.createText(this._el_47,'\n                ',(null as any));
    this._el_49 = import5.createRenderElement(this.renderer,this._el_47,'option',new import5.InlineArray2(2,'value','reissue'),(null as any));
    this._NgSelectOption_49_3 = new import35.Wrapper_NgSelectOption(new import13.ElementRef(this._el_49),this.renderer,this._SelectControlValueAccessor_47_3.context);
    this._NgSelectMultipleOption_49_4 = new import36.Wrapper_NgSelectMultipleOption(new import13.ElementRef(this._el_49),this.renderer,(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'Ré-édition',(null as any));
    this._text_51 = this.renderer.createText(this._el_47,'\n                ',(null as any));
    this._el_52 = import5.createRenderElement(this.renderer,this._el_47,'option',new import5.InlineArray2(2,'value','production'),(null as any));
    this._NgSelectOption_52_3 = new import35.Wrapper_NgSelectOption(new import13.ElementRef(this._el_52),this.renderer,this._SelectControlValueAccessor_47_3.context);
    this._NgSelectMultipleOption_52_4 = new import36.Wrapper_NgSelectMultipleOption(new import13.ElementRef(this._el_52),this.renderer,(null as any));
    this._text_53 = this.renderer.createText(this._el_52,'Production',(null as any));
    this._text_54 = this.renderer.createText(this._el_47,'\n              ',(null as any));
    this._text_55 = this.renderer.createText(this._el_45,'\n            ',(null as any));
    this._text_56 = this.renderer.createText(this._el_43,'\n            ',(null as any));
    this._el_57 = import5.createRenderElement(this.renderer,this._el_43,'div',new import5.InlineArray2(2,'class','input-group col-md-4'),(null as any));
    this._text_58 = this.renderer.createText(this._el_57,'\n              ',(null as any));
    this._el_59 = import5.createRenderElement(this.renderer,this._el_57,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_60 = import5.createRenderElement(this.renderer,this._el_59,'i',new import5.InlineArray2(2,'class','glyphicon glyphicon-cd'),(null as any));
    this._text_61 = this.renderer.createText(this._el_57,'\n              ',(null as any));
    this._el_62 = import5.createRenderElement(this.renderer,this._el_57,'input',new import5.InlineArray8(6,'class','form-control','formControlName','reference','type','text'),(null as any));
    this._DefaultValueAccessor_62_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_62));
    this._NG_VALUE_ACCESSOR_62_4 = [this._DefaultValueAccessor_62_3.context];
    this._FormControlName_62_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_62_4);
    this._NgControl_62_6 = this._FormControlName_62_5.context;
    this._NgControlStatus_62_7 = new import29.Wrapper_NgControlStatus(this._NgControl_62_6);
    this._text_63 = this.renderer.createText(this._el_57,'\n            ',(null as any));
    this._text_64 = this.renderer.createText(this._el_43,' \n             ',(null as any));
    this._el_65 = import5.createRenderElement(this.renderer,this._el_43,'div',new import5.InlineArray2(2,'class','input-group col-md-4'),(null as any));
    this._text_66 = this.renderer.createText(this._el_65,'\n              ',(null as any));
    this._el_67 = import5.createRenderElement(this.renderer,this._el_65,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_68 = import5.createRenderElement(this.renderer,this._el_67,'i',new import5.InlineArray2(2,'class','fa fa-calendar'),(null as any));
    this._text_69 = this.renderer.createText(this._el_65,'\n              ',(null as any));
    this._el_70 = import5.createRenderElement(this.renderer,this._el_65,'input',new import5.InlineArray8(6,'class','date-mask form-control','formControlName','date','type','text'),(null as any));
    this._DefaultValueAccessor_70_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_70));
    this._NG_VALUE_ACCESSOR_70_4 = [this._DefaultValueAccessor_70_3.context];
    this._FormControlName_70_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_70_4);
    this._NgControl_70_6 = this._FormControlName_70_5.context;
    this._NgControlStatus_70_7 = new import29.Wrapper_NgControlStatus(this._NgControl_70_6);
    this._text_71 = this.renderer.createText(this._el_65,'\n            ',(null as any));
    this._text_72 = this.renderer.createText(this._el_43,'   \n          ',(null as any));
    this._text_73 = this.renderer.createText(this._el_41,' \n          ',(null as any));
    this._el_74 = import5.createRenderElement(this.renderer,this._el_41,'div',new import5.InlineArray2(2,'class','block form-inline'),(null as any));
    this._text_75 = this.renderer.createText(this._el_74,'\n            ',(null as any));
    this._el_76 = import5.createRenderElement(this.renderer,this._el_74,'div',new import5.InlineArray2(2,'class','input-group col-md-3'),(null as any));
    this._text_77 = this.renderer.createText(this._el_76,'\n              ',(null as any));
    this._el_78 = import5.createRenderElement(this.renderer,this._el_76,'span',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_79 = import5.createRenderElement(this.renderer,this._el_78,'i',new import5.InlineArray2(2,'class','glyphicon glyphicon-euro'),(null as any));
    this._text_80 = this.renderer.createText(this._el_76,'\n              ',(null as any));
    this._el_81 = import5.createRenderElement(this.renderer,this._el_76,'input',new import5.InlineArray8(6,'class','price-mask form-control','formControlName','price','type','text'),(null as any));
    this._DefaultValueAccessor_81_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_81));
    this._NG_VALUE_ACCESSOR_81_4 = [this._DefaultValueAccessor_81_3.context];
    this._FormControlName_81_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_81_4);
    this._NgControl_81_6 = this._FormControlName_81_5.context;
    this._NgControlStatus_81_7 = new import29.Wrapper_NgControlStatus(this._NgControl_81_6);
    this._text_82 = this.renderer.createText(this._el_76,'\n            ',(null as any));
    this._text_83 = this.renderer.createText(this._el_74,'\n            ',(null as any));
    this._el_84 = import5.createRenderElement(this.renderer,this._el_74,'div',new import5.InlineArray2(2,'class','input-group col-md-4'),(null as any));
    this._text_85 = this.renderer.createText(this._el_84,'\n              ',(null as any));
    this._el_86 = import5.createRenderElement(this.renderer,this._el_84,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_87 = import5.createRenderElement(this.renderer,this._el_86,'i',new import5.InlineArray2(2,'class','glyphicon glyphicon-time'),(null as any));
    this._text_88 = this.renderer.createText(this._el_84,'\n              ',(null as any));
    this._el_89 = import5.createRenderElement(this.renderer,this._el_84,'input',new import5.InlineArray8(6,'class','length-mask form-control','formControlName','length','type','text'),(null as any));
    this._DefaultValueAccessor_89_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_89));
    this._NG_VALUE_ACCESSOR_89_4 = [this._DefaultValueAccessor_89_3.context];
    this._FormControlName_89_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_89_4);
    this._NgControl_89_6 = this._FormControlName_89_5.context;
    this._NgControlStatus_89_7 = new import29.Wrapper_NgControlStatus(this._NgControl_89_6);
    this._text_90 = this.renderer.createText(this._el_84,'\n            ',(null as any));
    this._text_91 = this.renderer.createText(this._el_74,' \n            ',(null as any));
    this._el_92 = import5.createRenderElement(this.renderer,this._el_74,'div',new import5.InlineArray2(2,'class','input-group col-md-4'),(null as any));
    this._text_93 = this.renderer.createText(this._el_92,'\n              ',(null as any));
    this._el_94 = import5.createRenderElement(this.renderer,this._el_92,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_95 = import5.createRenderElement(this.renderer,this._el_94,'i',new import5.InlineArray2(2,'class','fa fa-external-link'),(null as any));
    this._text_96 = this.renderer.createText(this._el_92,'\n              ',(null as any));
    this._el_97 = import5.createRenderElement(this.renderer,this._el_92,'input',new import5.InlineArray8(8,'class','form-control','formControlName','url','readonly','','type','text'),(null as any));
    this._DefaultValueAccessor_97_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_97));
    this._NG_VALUE_ACCESSOR_97_4 = [this._DefaultValueAccessor_97_3.context];
    this._FormControlName_97_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_97_4);
    this._NgControl_97_6 = this._FormControlName_97_5.context;
    this._NgControlStatus_97_7 = new import29.Wrapper_NgControlStatus(this._NgControl_97_6);
    this._text_98 = this.renderer.createText(this._el_92,'\n            ',(null as any));
    this._text_99 = this.renderer.createText(this._el_74,'   \n          ',(null as any));
    this._text_100 = this.renderer.createText(this._el_41,'\n           ',(null as any));
    this._el_101 = import5.createRenderElement(this.renderer,this._el_41,'div',new import5.InlineArray2(2,'class','block form-inline'),(null as any));
    this._text_102 = this.renderer.createText(this._el_101,'\n            ',(null as any));
    this._anchor_103 = this.renderer.createTemplateAnchor(this._el_101,(null as any));
    this._appEl_103 = new import3.AppElement(103,101,this,this._anchor_103);
    this._TemplateRef_103_5 = new import25.TemplateRef_(this._appEl_103,viewFactory_ContentRecordEditComponent9);
    this._NgFor_103_6 = new import37.Wrapper_NgFor(this._appEl_103.vcRef,this._TemplateRef_103_5,this.parent.parentInjector.get(import39.IterableDiffers),this.parent.ref);
    this._text_104 = this.renderer.createText(this._el_101,' \n          ',(null as any));
    this._text_105 = this.renderer.createText(this._el_41,' \n          ',(null as any));
    this._anchor_106 = this.renderer.createTemplateAnchor(this._el_41,(null as any));
    this._appEl_106 = new import3.AppElement(106,41,this,this._anchor_106);
    this._TemplateRef_106_5 = new import25.TemplateRef_(this._appEl_106,viewFactory_ContentRecordEditComponent11);
    this._NgIf_106_6 = new import23.Wrapper_NgIf(this._appEl_106.vcRef,this._TemplateRef_106_5);
    this._text_107 = this.renderer.createText(this._el_41,'   \n        ',(null as any));
    this._text_108 = this.renderer.createText(this._el_39,'\n			',(null as any));
    this._text_109 = this.renderer.createText(this._el_2,'\n\n			 ',(null as any));
    this._el_110 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray4(4,'class','panel-heading','style','margin-bottom: 15px'),(null as any));
    this._text_111 = this.renderer.createText(this._el_110,'Œuvres',(null as any));
    this._text_112 = this.renderer.createText(this._el_2,'\n			',(null as any));
    this._el_113 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray4(4,'formArrayName','music_pieces','ngclass','panel-body'),(null as any));
    this._FormArrayName_113_3 = new import33.Wrapper_FormArrayName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_113_4 = this._FormArrayName_113_3.context;
    this._NgControlStatusGroup_113_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_113_4);
    this._text_114 = this.renderer.createText(this._el_113,'\n        ',(null as any));
    this._anchor_115 = this.renderer.createTemplateAnchor(this._el_113,(null as any));
    this._appEl_115 = new import3.AppElement(115,113,this,this._anchor_115);
    this._TemplateRef_115_5 = new import25.TemplateRef_(this._appEl_115,viewFactory_ContentRecordEditComponent12);
    this._NgFor_115_6 = new import37.Wrapper_NgFor(this._appEl_115.vcRef,this._TemplateRef_115_5,this.parent.parentInjector.get(import39.IterableDiffers),this.parent.ref);
    this._text_116 = this.renderer.createText(this._el_113,'\n        ',(null as any));
    this._anchor_117 = this.renderer.createTemplateAnchor(this._el_113,(null as any));
    this._appEl_117 = new import3.AppElement(117,113,this,this._anchor_117);
    this._TemplateRef_117_5 = new import25.TemplateRef_(this._appEl_117,viewFactory_ContentRecordEditComponent17);
    this._NgIf_117_6 = new import23.Wrapper_NgIf(this._appEl_117.vcRef,this._TemplateRef_117_5);
    this._text_118 = this.renderer.createText(this._el_113,'\n      ',(null as any));
    this._text_119 = this.renderer.createText(this._el_2,' \n\n			 ',(null as any));
    this._el_120 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_121 = this.renderer.createText(this._el_120,'Description',(null as any));
    this._text_122 = this.renderer.createText(this._el_2,'\n			',(null as any));
    this._el_123 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_124 = this.renderer.createText(this._el_123,'\n      ',(null as any));
    this._el_125 = import5.createRenderElement(this.renderer,this._el_123,'div',new import5.InlineArray2(2,'formGroupName','description'),(null as any));
    this._FormGroupName_125_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_125_4 = this._FormGroupName_125_3.context;
    this._NgControlStatusGroup_125_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_125_4);
    this._text_126 = this.renderer.createText(this._el_125,'\n        ',(null as any));
    this._anchor_127 = this.renderer.createTemplateAnchor(this._el_125,(null as any));
    this._appEl_127 = new import3.AppElement(127,125,this,this._anchor_127);
    this._TemplateRef_127_5 = new import25.TemplateRef_(this._appEl_127,viewFactory_ContentRecordEditComponent18);
    this._NgFor_127_6 = new import37.Wrapper_NgFor(this._appEl_127.vcRef,this._TemplateRef_127_5,this.parent.parentInjector.get(import39.IterableDiffers),this.parent.ref);
    this._text_128 = this.renderer.createText(this._el_125,'\n      ',(null as any));
    this._text_129 = this.renderer.createText(this._el_123,'\n      ',(null as any));
    this._text_130 = this.renderer.createText(this._el_2,' \n\n			 ',(null as any));
    this._el_131 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_132 = this.renderer.createText(this._el_131,'Tags',(null as any));
    this._text_133 = this.renderer.createText(this._el_2,'\n			',(null as any));
    this._el_134 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray4(4,'class','panel-body','formArrayName','tags'),(null as any));
    this._FormArrayName_134_3 = new import33.Wrapper_FormArrayName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_134_4 = this._FormArrayName_134_3.context;
    this._NgControlStatusGroup_134_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_134_4);
    this._text_135 = this.renderer.createText(this._el_134,'\n        ',(null as any));
    this._el_136 = import5.createRenderElement(this.renderer,this._el_134,'div',new import5.InlineArray2(2,'class','form-inline'),(null as any));
    this._text_137 = this.renderer.createText(this._el_136,'\n          ',(null as any));
    this._anchor_138 = this.renderer.createTemplateAnchor(this._el_136,(null as any));
    this._appEl_138 = new import3.AppElement(138,136,this,this._anchor_138);
    this._TemplateRef_138_5 = new import25.TemplateRef_(this._appEl_138,viewFactory_ContentRecordEditComponent19);
    this._NgFor_138_6 = new import37.Wrapper_NgFor(this._appEl_138.vcRef,this._TemplateRef_138_5,this.parent.parentInjector.get(import39.IterableDiffers),this.parent.ref);
    this._text_139 = this.renderer.createText(this._el_136,' \n          ',(null as any));
    this._anchor_140 = this.renderer.createTemplateAnchor(this._el_136,(null as any));
    this._appEl_140 = new import3.AppElement(140,136,this,this._anchor_140);
    this._TemplateRef_140_5 = new import25.TemplateRef_(this._appEl_140,viewFactory_ContentRecordEditComponent21);
    this._NgIf_140_6 = new import23.Wrapper_NgIf(this._appEl_140.vcRef,this._TemplateRef_140_5);
    this._text_141 = this.renderer.createText(this._el_136,'\n			  ',(null as any));
    this._text_142 = this.renderer.createText(this._el_134,'\n      ',(null as any));
    this._text_143 = this.renderer.createText(this._el_2,' \n\n			',(null as any));
    this._el_144 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_145 = this.renderer.createText(this._el_144,'\n				',(null as any));
    this._el_146 = import5.createRenderElement(this.renderer,this._el_144,'div',new import5.InlineArray2(2,'class','form-inline'),(null as any));
    this._text_147 = this.renderer.createText(this._el_146,' \n					',(null as any));
    this._el_148 = import5.createRenderElement(this.renderer,this._el_146,'div',new import5.InlineArray2(2,'class','input-group col-lg-3 col-md-4 col-sm-5 pull-right'),(null as any));
    this._text_149 = this.renderer.createText(this._el_148,'\n						',(null as any));
    this._el_150 = import5.createRenderElement(this.renderer,this._el_148,'input',new import5.InlineArray8(6,'class','btn btn-info','type','submit','value','Enregistrer le nouveau disque'),(null as any));
    this._text_151 = this.renderer.createText(this._el_148,' \n					',(null as any));
    this._text_152 = this.renderer.createText(this._el_146,'  \n				',(null as any));
    this._text_153 = this.renderer.createText(this._el_144,'\n			',(null as any));
    this._text_154 = this.renderer.createText(this._el_2,'\n\n      ',(null as any));
    this._text_155 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'ngSubmit',this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_0,'submit',this.eventHandler(this._handle_submit_0_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_0,'reset',this.eventHandler(this._handle_reset_0_2.bind(this)));
    const subscription_0:any = this._FormGroupDirective_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_11,'change',this.eventHandler(this._handle_change_11_0.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_11,'blur',this.eventHandler(this._handle_blur_11_1.bind(this)));
    var disposable_5:Function = this.renderer.listen(this._el_18,'input',this.eventHandler(this._handle_input_18_0.bind(this)));
    var disposable_6:Function = this.renderer.listen(this._el_18,'blur',this.eventHandler(this._handle_blur_18_1.bind(this)));
    var disposable_7:Function = this.renderer.listen(this._el_47,'change',this.eventHandler(this._handle_change_47_0.bind(this)));
    var disposable_8:Function = this.renderer.listen(this._el_47,'blur',this.eventHandler(this._handle_blur_47_1.bind(this)));
    var disposable_9:Function = this.renderer.listen(this._el_62,'input',this.eventHandler(this._handle_input_62_0.bind(this)));
    var disposable_10:Function = this.renderer.listen(this._el_62,'blur',this.eventHandler(this._handle_blur_62_1.bind(this)));
    var disposable_11:Function = this.renderer.listen(this._el_70,'input',this.eventHandler(this._handle_input_70_0.bind(this)));
    var disposable_12:Function = this.renderer.listen(this._el_70,'blur',this.eventHandler(this._handle_blur_70_1.bind(this)));
    var disposable_13:Function = this.renderer.listen(this._el_81,'input',this.eventHandler(this._handle_input_81_0.bind(this)));
    var disposable_14:Function = this.renderer.listen(this._el_81,'blur',this.eventHandler(this._handle_blur_81_1.bind(this)));
    var disposable_15:Function = this.renderer.listen(this._el_89,'input',this.eventHandler(this._handle_input_89_0.bind(this)));
    var disposable_16:Function = this.renderer.listen(this._el_89,'blur',this.eventHandler(this._handle_blur_89_1.bind(this)));
    var disposable_17:Function = this.renderer.listen(this._el_94,'click',this.eventHandler(this._handle_click_94_0.bind(this)));
    var disposable_18:Function = this.renderer.listen(this._el_97,'ngModelChange',this.eventHandler(this._handle_ngModelChange_97_0.bind(this)));
    var disposable_19:Function = this.renderer.listen(this._el_97,'input',this.eventHandler(this._handle_input_97_1.bind(this)));
    var disposable_20:Function = this.renderer.listen(this._el_97,'blur',this.eventHandler(this._handle_blur_97_2.bind(this)));
    const subscription_1:any = this._FormControlName_97_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_97_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._anchor_21,
      this._text_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._text_38,
      this._el_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._el_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._text_51,
      this._el_52,
      this._text_53,
      this._text_54,
      this._text_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._el_59,
      this._el_60,
      this._text_61,
      this._el_62,
      this._text_63,
      this._text_64,
      this._el_65,
      this._text_66,
      this._el_67,
      this._el_68,
      this._text_69,
      this._el_70,
      this._text_71,
      this._text_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._el_76,
      this._text_77,
      this._el_78,
      this._el_79,
      this._text_80,
      this._el_81,
      this._text_82,
      this._text_83,
      this._el_84,
      this._text_85,
      this._el_86,
      this._el_87,
      this._text_88,
      this._el_89,
      this._text_90,
      this._text_91,
      this._el_92,
      this._text_93,
      this._el_94,
      this._el_95,
      this._text_96,
      this._el_97,
      this._text_98,
      this._text_99,
      this._text_100,
      this._el_101,
      this._text_102,
      this._anchor_103,
      this._text_104,
      this._text_105,
      this._anchor_106,
      this._text_107,
      this._text_108,
      this._text_109,
      this._el_110,
      this._text_111,
      this._text_112,
      this._el_113,
      this._text_114,
      this._anchor_115,
      this._text_116,
      this._anchor_117,
      this._text_118,
      this._text_119,
      this._el_120,
      this._text_121,
      this._text_122,
      this._el_123,
      this._text_124,
      this._el_125,
      this._text_126,
      this._anchor_127,
      this._text_128,
      this._text_129,
      this._text_130,
      this._el_131,
      this._text_132,
      this._text_133,
      this._el_134,
      this._text_135,
      this._el_136,
      this._text_137,
      this._anchor_138,
      this._text_139,
      this._anchor_140,
      this._text_141,
      this._text_142,
      this._text_143,
      this._el_144,
      this._text_145,
      this._el_146,
      this._text_147,
      this._el_148,
      this._text_149,
      this._el_150,
      this._text_151,
      this._text_152,
      this._text_153,
      this._text_154,
      this._text_155
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8,
      disposable_9,
      disposable_10,
      disposable_11,
      disposable_12,
      disposable_13,
      disposable_14,
      disposable_15,
      disposable_16,
      disposable_17,
      disposable_18,
      disposable_19,
      disposable_20
    ]
    ,[
      subscription_0,
      subscription_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import40.CheckboxControlValueAccessor) && (11 === requestNodeIndex))) { return this._CheckboxControlValueAccessor_11_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (11 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_11_4; }
    if (((token === import42.FormControlName) && (11 === requestNodeIndex))) { return this._FormControlName_11_5.context; }
    if (((token === import43.NgControl) && (11 === requestNodeIndex))) { return this._NgControl_11_6; }
    if (((token === import44.NgControlStatus) && (11 === requestNodeIndex))) { return this._NgControlStatus_11_7.context; }
    if (((token === import45.DefaultValueAccessor) && (18 === requestNodeIndex))) { return this._DefaultValueAccessor_18_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (18 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_18_4; }
    if (((token === import42.FormControlName) && (18 === requestNodeIndex))) { return this._FormControlName_18_5.context; }
    if (((token === import43.NgControl) && (18 === requestNodeIndex))) { return this._NgControl_18_6; }
    if (((token === import44.NgControlStatus) && (18 === requestNodeIndex))) { return this._NgControlStatus_18_7.context; }
    if (((token === import25.TemplateRef) && (21 === requestNodeIndex))) { return this._TemplateRef_21_5; }
    if (((token === import27.NgIf) && (21 === requestNodeIndex))) { return this._NgIf_21_6.context; }
    if (((token === import46.ImageUploadComponent) && ((31 <= requestNodeIndex) && (requestNodeIndex <= 32)))) { return this._ImageUploadComponent_31_4.context; }
    if (((token === import47.FormGroupName) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 33)))) { return this._FormGroupName_29_3.context; }
    if (((token === import48.ControlContainer) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 33)))) { return this._ControlContainer_29_4; }
    if (((token === import44.NgControlStatusGroup) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 33)))) { return this._NgControlStatusGroup_29_5.context; }
    if (((token === import49.NgSelectOption) && ((49 <= requestNodeIndex) && (requestNodeIndex <= 50)))) { return this._NgSelectOption_49_3.context; }
    if (((token === import50.NgSelectMultipleOption) && ((49 <= requestNodeIndex) && (requestNodeIndex <= 50)))) { return this._NgSelectMultipleOption_49_4.context; }
    if (((token === import49.NgSelectOption) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 53)))) { return this._NgSelectOption_52_3.context; }
    if (((token === import50.NgSelectMultipleOption) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 53)))) { return this._NgSelectMultipleOption_52_4.context; }
    if (((token === import49.SelectControlValueAccessor) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 54)))) { return this._SelectControlValueAccessor_47_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 54)))) { return this._NG_VALUE_ACCESSOR_47_4; }
    if (((token === import42.FormControlName) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 54)))) { return this._FormControlName_47_5.context; }
    if (((token === import43.NgControl) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 54)))) { return this._NgControl_47_6; }
    if (((token === import44.NgControlStatus) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 54)))) { return this._NgControlStatus_47_7.context; }
    if (((token === import45.DefaultValueAccessor) && (62 === requestNodeIndex))) { return this._DefaultValueAccessor_62_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (62 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_62_4; }
    if (((token === import42.FormControlName) && (62 === requestNodeIndex))) { return this._FormControlName_62_5.context; }
    if (((token === import43.NgControl) && (62 === requestNodeIndex))) { return this._NgControl_62_6; }
    if (((token === import44.NgControlStatus) && (62 === requestNodeIndex))) { return this._NgControlStatus_62_7.context; }
    if (((token === import45.DefaultValueAccessor) && (70 === requestNodeIndex))) { return this._DefaultValueAccessor_70_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (70 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_70_4; }
    if (((token === import42.FormControlName) && (70 === requestNodeIndex))) { return this._FormControlName_70_5.context; }
    if (((token === import43.NgControl) && (70 === requestNodeIndex))) { return this._NgControl_70_6; }
    if (((token === import44.NgControlStatus) && (70 === requestNodeIndex))) { return this._NgControlStatus_70_7.context; }
    if (((token === import45.DefaultValueAccessor) && (81 === requestNodeIndex))) { return this._DefaultValueAccessor_81_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (81 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_81_4; }
    if (((token === import42.FormControlName) && (81 === requestNodeIndex))) { return this._FormControlName_81_5.context; }
    if (((token === import43.NgControl) && (81 === requestNodeIndex))) { return this._NgControl_81_6; }
    if (((token === import44.NgControlStatus) && (81 === requestNodeIndex))) { return this._NgControlStatus_81_7.context; }
    if (((token === import45.DefaultValueAccessor) && (89 === requestNodeIndex))) { return this._DefaultValueAccessor_89_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (89 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_89_4; }
    if (((token === import42.FormControlName) && (89 === requestNodeIndex))) { return this._FormControlName_89_5.context; }
    if (((token === import43.NgControl) && (89 === requestNodeIndex))) { return this._NgControl_89_6; }
    if (((token === import44.NgControlStatus) && (89 === requestNodeIndex))) { return this._NgControlStatus_89_7.context; }
    if (((token === import45.DefaultValueAccessor) && (97 === requestNodeIndex))) { return this._DefaultValueAccessor_97_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (97 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_97_4; }
    if (((token === import42.FormControlName) && (97 === requestNodeIndex))) { return this._FormControlName_97_5.context; }
    if (((token === import43.NgControl) && (97 === requestNodeIndex))) { return this._NgControl_97_6; }
    if (((token === import44.NgControlStatus) && (97 === requestNodeIndex))) { return this._NgControlStatus_97_7.context; }
    if (((token === import25.TemplateRef) && (103 === requestNodeIndex))) { return this._TemplateRef_103_5; }
    if (((token === import51.NgFor) && (103 === requestNodeIndex))) { return this._NgFor_103_6.context; }
    if (((token === import25.TemplateRef) && (106 === requestNodeIndex))) { return this._TemplateRef_106_5; }
    if (((token === import27.NgIf) && (106 === requestNodeIndex))) { return this._NgIf_106_6.context; }
    if (((token === import25.TemplateRef) && (115 === requestNodeIndex))) { return this._TemplateRef_115_5; }
    if (((token === import51.NgFor) && (115 === requestNodeIndex))) { return this._NgFor_115_6.context; }
    if (((token === import25.TemplateRef) && (117 === requestNodeIndex))) { return this._TemplateRef_117_5; }
    if (((token === import27.NgIf) && (117 === requestNodeIndex))) { return this._NgIf_117_6.context; }
    if (((token === import47.FormArrayName) && ((113 <= requestNodeIndex) && (requestNodeIndex <= 118)))) { return this._FormArrayName_113_3.context; }
    if (((token === import48.ControlContainer) && ((113 <= requestNodeIndex) && (requestNodeIndex <= 118)))) { return this._ControlContainer_113_4; }
    if (((token === import44.NgControlStatusGroup) && ((113 <= requestNodeIndex) && (requestNodeIndex <= 118)))) { return this._NgControlStatusGroup_113_5.context; }
    if (((token === import25.TemplateRef) && (127 === requestNodeIndex))) { return this._TemplateRef_127_5; }
    if (((token === import51.NgFor) && (127 === requestNodeIndex))) { return this._NgFor_127_6.context; }
    if (((token === import47.FormGroupName) && ((125 <= requestNodeIndex) && (requestNodeIndex <= 128)))) { return this._FormGroupName_125_3.context; }
    if (((token === import48.ControlContainer) && ((125 <= requestNodeIndex) && (requestNodeIndex <= 128)))) { return this._ControlContainer_125_4; }
    if (((token === import44.NgControlStatusGroup) && ((125 <= requestNodeIndex) && (requestNodeIndex <= 128)))) { return this._NgControlStatusGroup_125_5.context; }
    if (((token === import25.TemplateRef) && (138 === requestNodeIndex))) { return this._TemplateRef_138_5; }
    if (((token === import51.NgFor) && (138 === requestNodeIndex))) { return this._NgFor_138_6.context; }
    if (((token === import25.TemplateRef) && (140 === requestNodeIndex))) { return this._TemplateRef_140_5; }
    if (((token === import27.NgIf) && (140 === requestNodeIndex))) { return this._NgIf_140_6.context; }
    if (((token === import47.FormArrayName) && ((134 <= requestNodeIndex) && (requestNodeIndex <= 142)))) { return this._FormArrayName_134_3.context; }
    if (((token === import48.ControlContainer) && ((134 <= requestNodeIndex) && (requestNodeIndex <= 142)))) { return this._ControlContainer_134_4; }
    if (((token === import44.NgControlStatusGroup) && ((134 <= requestNodeIndex) && (requestNodeIndex <= 142)))) { return this._NgControlStatusGroup_134_5.context; }
    if (((token === import52.FormGroupDirective) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 155)))) { return this._FormGroupDirective_0_3.context; }
    if (((token === import48.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 155)))) { return this._ControlContainer_0_4; }
    if (((token === import44.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 155)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parent.context.recordForm;
    this._FormGroupDirective_0_3.check_form(currVal_0_0_0,throwOnChange,false);
    this._FormGroupDirective_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._CheckboxControlValueAccessor_11_3.detectChangesInInputProps(this,this._el_11,throwOnChange);
    const currVal_11_1_0:any = 'active';
    this._FormControlName_11_5.check_name(currVal_11_1_0,throwOnChange,false);
    this._FormControlName_11_5.detectChangesInInputProps(this,this._el_11,throwOnChange);
    this._NgControlStatus_11_7.detectChangesInInputProps(this,this._el_11,throwOnChange);
    this._DefaultValueAccessor_18_3.detectChangesInInputProps(this,this._el_18,throwOnChange);
    const currVal_18_1_0:any = 'title';
    this._FormControlName_18_5.check_name(currVal_18_1_0,throwOnChange,false);
    this._FormControlName_18_5.detectChangesInInputProps(this,this._el_18,throwOnChange);
    this._NgControlStatus_18_7.detectChangesInInputProps(this,this._el_18,throwOnChange);
    const currVal_21_0_0:any = (this.parent.context.action == 'update');
    this._NgIf_21_6.check_ngIf(currVal_21_0_0,throwOnChange,false);
    this._NgIf_21_6.detectChangesInInputProps(this,this._anchor_21,throwOnChange);
    const currVal_29_0_0:any = 'cover';
    this._FormGroupName_29_3.check_name(currVal_29_0_0,throwOnChange,false);
    this._FormGroupName_29_3.detectChangesInInputProps(this,this._el_29,throwOnChange);
    this._NgControlStatusGroup_29_5.detectChangesInInputProps(this,this._el_29,throwOnChange);
    const currVal_31_0_0:any = this.parent.context.recordForm;
    this._ImageUploadComponent_31_4.check_form(currVal_31_0_0,throwOnChange,false);
    const currVal_31_0_1:any = 'cover';
    this._ImageUploadComponent_31_4.check_groupName(currVal_31_0_1,throwOnChange,false);
    const currVal_31_0_2:any = '/data/covers/';
    this._ImageUploadComponent_31_4.check_imagePath(currVal_31_0_2,throwOnChange,false);
    const currVal_31_0_3:any = '/api/data/covers/add';
    this._ImageUploadComponent_31_4.check_addApi(currVal_31_0_3,throwOnChange,false);
    const currVal_31_0_4:any = '/api/data/covers/delete/';
    this._ImageUploadComponent_31_4.check_deleteApi(currVal_31_0_4,throwOnChange,false);
    const currVal_31_0_5:any = 'covers';
    this._ImageUploadComponent_31_4.check_deleteDir(currVal_31_0_5,throwOnChange,false);
    const currVal_31_0_6:any = 300;
    this._ImageUploadComponent_31_4.check_thumbSize(currVal_31_0_6,throwOnChange,false);
    this._ImageUploadComponent_31_4.detectChangesInInputProps(this,this._el_31,throwOnChange);
    this._SelectControlValueAccessor_47_3.detectChangesInInputProps(this,this._el_47,throwOnChange);
    const currVal_47_1_0:any = 'type';
    this._FormControlName_47_5.check_name(currVal_47_1_0,throwOnChange,false);
    this._FormControlName_47_5.detectChangesInInputProps(this,this._el_47,throwOnChange);
    this._NgControlStatus_47_7.detectChangesInInputProps(this,this._el_47,throwOnChange);
    const currVal_49_0_0:any = 'reissue';
    this._NgSelectOption_49_3.check_value(currVal_49_0_0,throwOnChange,false);
    this._NgSelectOption_49_3.detectChangesInInputProps(this,this._el_49,throwOnChange);
    const currVal_49_1_0:any = 'reissue';
    this._NgSelectMultipleOption_49_4.check_value(currVal_49_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_49_4.detectChangesInInputProps(this,this._el_49,throwOnChange);
    const currVal_52_0_0:any = 'production';
    this._NgSelectOption_52_3.check_value(currVal_52_0_0,throwOnChange,false);
    this._NgSelectOption_52_3.detectChangesInInputProps(this,this._el_52,throwOnChange);
    const currVal_52_1_0:any = 'production';
    this._NgSelectMultipleOption_52_4.check_value(currVal_52_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_52_4.detectChangesInInputProps(this,this._el_52,throwOnChange);
    this._DefaultValueAccessor_62_3.detectChangesInInputProps(this,this._el_62,throwOnChange);
    const currVal_62_1_0:any = 'reference';
    this._FormControlName_62_5.check_name(currVal_62_1_0,throwOnChange,false);
    this._FormControlName_62_5.detectChangesInInputProps(this,this._el_62,throwOnChange);
    this._NgControlStatus_62_7.detectChangesInInputProps(this,this._el_62,throwOnChange);
    this._DefaultValueAccessor_70_3.detectChangesInInputProps(this,this._el_70,throwOnChange);
    const currVal_70_1_0:any = 'date';
    this._FormControlName_70_5.check_name(currVal_70_1_0,throwOnChange,false);
    this._FormControlName_70_5.detectChangesInInputProps(this,this._el_70,throwOnChange);
    this._NgControlStatus_70_7.detectChangesInInputProps(this,this._el_70,throwOnChange);
    this._DefaultValueAccessor_81_3.detectChangesInInputProps(this,this._el_81,throwOnChange);
    const currVal_81_1_0:any = 'price';
    this._FormControlName_81_5.check_name(currVal_81_1_0,throwOnChange,false);
    this._FormControlName_81_5.detectChangesInInputProps(this,this._el_81,throwOnChange);
    this._NgControlStatus_81_7.detectChangesInInputProps(this,this._el_81,throwOnChange);
    this._DefaultValueAccessor_89_3.detectChangesInInputProps(this,this._el_89,throwOnChange);
    const currVal_89_1_0:any = 'length';
    this._FormControlName_89_5.check_name(currVal_89_1_0,throwOnChange,false);
    this._FormControlName_89_5.detectChangesInInputProps(this,this._el_89,throwOnChange);
    this._NgControlStatus_89_7.detectChangesInInputProps(this,this._el_89,throwOnChange);
    this._DefaultValueAccessor_97_3.detectChangesInInputProps(this,this._el_97,throwOnChange);
    const currVal_97_1_0:any = 'url';
    this._FormControlName_97_5.check_name(currVal_97_1_0,throwOnChange,false);
    const currVal_97_1_1:any = this.parent.context.url;
    this._FormControlName_97_5.check_model(currVal_97_1_1,throwOnChange,false);
    this._FormControlName_97_5.detectChangesInInputProps(this,this._el_97,throwOnChange);
    this._NgControlStatus_97_7.detectChangesInInputProps(this,this._el_97,throwOnChange);
    const currVal_103_0_0:any = this.parent.context.recordForm.controls.original_references.controls;
    this._NgFor_103_6.check_ngForOf(currVal_103_0_0,throwOnChange,false);
    this._NgFor_103_6.detectChangesInInputProps(this,this._anchor_103,throwOnChange);
    const currVal_106_0_0:any = (this.parent.context.recordForm.controls.original_references.controls.length == 0);
    this._NgIf_106_6.check_ngIf(currVal_106_0_0,throwOnChange,false);
    this._NgIf_106_6.detectChangesInInputProps(this,this._anchor_106,throwOnChange);
    const currVal_113_0_0:any = 'music_pieces';
    this._FormArrayName_113_3.check_name(currVal_113_0_0,throwOnChange,false);
    this._FormArrayName_113_3.detectChangesInInputProps(this,this._el_113,throwOnChange);
    this._NgControlStatusGroup_113_5.detectChangesInInputProps(this,this._el_113,throwOnChange);
    const currVal_115_0_0:any = this.parent.context.recordForm.get('music_pieces').controls;
    this._NgFor_115_6.check_ngForOf(currVal_115_0_0,throwOnChange,false);
    this._NgFor_115_6.detectChangesInInputProps(this,this._anchor_115,throwOnChange);
    const currVal_117_0_0:any = (this.parent.context.recordForm.get('music_pieces').controls.length == 0);
    this._NgIf_117_6.check_ngIf(currVal_117_0_0,throwOnChange,false);
    this._NgIf_117_6.detectChangesInInputProps(this,this._anchor_117,throwOnChange);
    const currVal_125_0_0:any = 'description';
    this._FormGroupName_125_3.check_name(currVal_125_0_0,throwOnChange,false);
    this._FormGroupName_125_3.detectChangesInInputProps(this,this._el_125,throwOnChange);
    this._NgControlStatusGroup_125_5.detectChangesInInputProps(this,this._el_125,throwOnChange);
    const currVal_127_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_127_6.check_ngForOf(currVal_127_0_0,throwOnChange,false);
    this._NgFor_127_6.detectChangesInInputProps(this,this._anchor_127,throwOnChange);
    const currVal_134_0_0:any = 'tags';
    this._FormArrayName_134_3.check_name(currVal_134_0_0,throwOnChange,false);
    this._FormArrayName_134_3.detectChangesInInputProps(this,this._el_134,throwOnChange);
    this._NgControlStatusGroup_134_5.detectChangesInInputProps(this,this._el_134,throwOnChange);
    const currVal_138_0_0:any = this.parent.context.recordForm.controls.tags.controls;
    this._NgFor_138_6.check_ngForOf(currVal_138_0_0,throwOnChange,false);
    this._NgFor_138_6.detectChangesInInputProps(this,this._anchor_138,throwOnChange);
    const currVal_140_0_0:any = (this.parent.context.recordForm.controls.tags.controls.length == 0);
    this._NgIf_140_6.check_ngIf(currVal_140_0_0,throwOnChange,false);
    this._NgIf_140_6.detectChangesInInputProps(this,this._anchor_140,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._FormGroupDirective_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._CheckboxControlValueAccessor_11_3.detectChangesInHostProps(this,this._el_11,throwOnChange);
    this._FormControlName_11_5.detectChangesInHostProps(this,this._el_11,throwOnChange);
    this._NgControlStatus_11_7.detectChangesInHostProps(this,this._el_11,throwOnChange);
    this._DefaultValueAccessor_18_3.detectChangesInHostProps(this,this._el_18,throwOnChange);
    this._FormControlName_18_5.detectChangesInHostProps(this,this._el_18,throwOnChange);
    this._NgControlStatus_18_7.detectChangesInHostProps(this,this._el_18,throwOnChange);
    this._FormGroupName_29_3.detectChangesInHostProps(this,this._el_29,throwOnChange);
    this._NgControlStatusGroup_29_5.detectChangesInHostProps(this,this._el_29,throwOnChange);
    this._ImageUploadComponent_31_4.detectChangesInHostProps(this,this._el_31,throwOnChange);
    this._SelectControlValueAccessor_47_3.detectChangesInHostProps(this,this._el_47,throwOnChange);
    this._FormControlName_47_5.detectChangesInHostProps(this,this._el_47,throwOnChange);
    this._NgControlStatus_47_7.detectChangesInHostProps(this,this._el_47,throwOnChange);
    this._NgSelectOption_49_3.detectChangesInHostProps(this,this._el_49,throwOnChange);
    this._NgSelectMultipleOption_49_4.detectChangesInHostProps(this,this._el_49,throwOnChange);
    this._NgSelectOption_52_3.detectChangesInHostProps(this,this._el_52,throwOnChange);
    this._NgSelectMultipleOption_52_4.detectChangesInHostProps(this,this._el_52,throwOnChange);
    this._DefaultValueAccessor_62_3.detectChangesInHostProps(this,this._el_62,throwOnChange);
    this._FormControlName_62_5.detectChangesInHostProps(this,this._el_62,throwOnChange);
    this._NgControlStatus_62_7.detectChangesInHostProps(this,this._el_62,throwOnChange);
    this._DefaultValueAccessor_70_3.detectChangesInHostProps(this,this._el_70,throwOnChange);
    this._FormControlName_70_5.detectChangesInHostProps(this,this._el_70,throwOnChange);
    this._NgControlStatus_70_7.detectChangesInHostProps(this,this._el_70,throwOnChange);
    this._DefaultValueAccessor_81_3.detectChangesInHostProps(this,this._el_81,throwOnChange);
    this._FormControlName_81_5.detectChangesInHostProps(this,this._el_81,throwOnChange);
    this._NgControlStatus_81_7.detectChangesInHostProps(this,this._el_81,throwOnChange);
    this._DefaultValueAccessor_89_3.detectChangesInHostProps(this,this._el_89,throwOnChange);
    this._FormControlName_89_5.detectChangesInHostProps(this,this._el_89,throwOnChange);
    this._NgControlStatus_89_7.detectChangesInHostProps(this,this._el_89,throwOnChange);
    this._DefaultValueAccessor_97_3.detectChangesInHostProps(this,this._el_97,throwOnChange);
    this._FormControlName_97_5.detectChangesInHostProps(this,this._el_97,throwOnChange);
    this._NgControlStatus_97_7.detectChangesInHostProps(this,this._el_97,throwOnChange);
    this._FormArrayName_113_3.detectChangesInHostProps(this,this._el_113,throwOnChange);
    this._NgControlStatusGroup_113_5.detectChangesInHostProps(this,this._el_113,throwOnChange);
    this._FormGroupName_125_3.detectChangesInHostProps(this,this._el_125,throwOnChange);
    this._NgControlStatusGroup_125_5.detectChangesInHostProps(this,this._el_125,throwOnChange);
    this._FormArrayName_134_3.detectChangesInHostProps(this,this._el_134,throwOnChange);
    this._NgControlStatusGroup_134_5.detectChangesInHostProps(this,this._el_134,throwOnChange);
    const currVal_241:any = this.parent.context.recordForm.invalid;
    if (import5.checkBinding(throwOnChange,this._expr_241,currVal_241)) {
      this.renderer.setElementProperty(this._el_150,'disabled',currVal_241);
      this._expr_241 = currVal_241;
    }
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._ImageUploadComponent_31_4.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._FormControlName_11_5.context.ngOnDestroy();
    this._FormControlName_18_5.context.ngOnDestroy();
    this._NgSelectOption_49_3.context.ngOnDestroy();
    this._NgSelectMultipleOption_49_4.context.ngOnDestroy();
    this._NgSelectOption_52_3.context.ngOnDestroy();
    this._NgSelectMultipleOption_52_4.context.ngOnDestroy();
    this._FormControlName_47_5.context.ngOnDestroy();
    this._FormControlName_62_5.context.ngOnDestroy();
    this._FormControlName_70_5.context.ngOnDestroy();
    this._FormControlName_81_5.context.ngOnDestroy();
    this._FormControlName_89_5.context.ngOnDestroy();
    this._FormControlName_97_5.context.ngOnDestroy();
    this._FormArrayName_113_3.context.ngOnDestroy();
    this._FormArrayName_134_3.context.ngOnDestroy();
  }
  private _handle_ngSubmit_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.onSubmit()) !== false);
    return (true && pd_0_0);
  }
  private _handle_submit_0_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._FormGroupDirective_0_3.context.onSubmit($event)) !== false);
    return (true && pd_0_0);
  }
  private _handle_reset_0_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._FormGroupDirective_0_3.context.onReset()) !== false);
    return (true && pd_0_0);
  }
  private _handle_change_11_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_11_0:any = ((<any>this._CheckboxControlValueAccessor_11_3.context.onChange($event.target.checked)) !== false);
    return (true && pd_11_0);
  }
  private _handle_blur_11_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_11_0:any = ((<any>this._CheckboxControlValueAccessor_11_3.context.onTouched()) !== false);
    return (true && pd_11_0);
  }
  private _handle_input_18_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_18_0:any = ((<any>this._DefaultValueAccessor_18_3.context.onChange($event.target.value)) !== false);
    return (true && pd_18_0);
  }
  private _handle_blur_18_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_18_0:any = ((<any>this._DefaultValueAccessor_18_3.context.onTouched()) !== false);
    return (true && pd_18_0);
  }
  private _handle_change_47_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_47_0:any = ((<any>this._SelectControlValueAccessor_47_3.context.onChange($event.target.value)) !== false);
    return (true && pd_47_0);
  }
  private _handle_blur_47_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_47_0:any = ((<any>this._SelectControlValueAccessor_47_3.context.onTouched()) !== false);
    return (true && pd_47_0);
  }
  private _handle_input_62_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_62_0:any = ((<any>this._DefaultValueAccessor_62_3.context.onChange($event.target.value)) !== false);
    return (true && pd_62_0);
  }
  private _handle_blur_62_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_62_0:any = ((<any>this._DefaultValueAccessor_62_3.context.onTouched()) !== false);
    return (true && pd_62_0);
  }
  private _handle_input_70_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_70_0:any = ((<any>this._DefaultValueAccessor_70_3.context.onChange($event.target.value)) !== false);
    return (true && pd_70_0);
  }
  private _handle_blur_70_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_70_0:any = ((<any>this._DefaultValueAccessor_70_3.context.onTouched()) !== false);
    return (true && pd_70_0);
  }
  private _handle_input_81_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_81_0:any = ((<any>this._DefaultValueAccessor_81_3.context.onChange($event.target.value)) !== false);
    return (true && pd_81_0);
  }
  private _handle_blur_81_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_81_0:any = ((<any>this._DefaultValueAccessor_81_3.context.onTouched()) !== false);
    return (true && pd_81_0);
  }
  private _handle_input_89_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_89_0:any = ((<any>this._DefaultValueAccessor_89_3.context.onChange($event.target.value)) !== false);
    return (true && pd_89_0);
  }
  private _handle_blur_89_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_89_0:any = ((<any>this._DefaultValueAccessor_89_3.context.onTouched()) !== false);
    return (true && pd_89_0);
  }
  private _handle_click_94_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_94_0:any = ((<any>this.parent.context.buildUrl()) !== false);
    return (true && pd_94_0);
  }
  private _handle_ngModelChange_97_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_97_0:any = ((<any>(this.parent.context.url = $event)) !== false);
    return (true && pd_97_0);
  }
  private _handle_input_97_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_97_0:any = ((<any>this._DefaultValueAccessor_97_3.context.onChange($event.target.value)) !== false);
    return (true && pd_97_0);
  }
  private _handle_blur_97_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_97_0:any = ((<any>this._DefaultValueAccessor_97_3.context.onTouched()) !== false);
    return (true && pd_97_0);
  }
}
function viewFactory_ContentRecordEditComponent5(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _anchor_3:any;
  /*private*/ _appEl_3:import3.AppElement;
  _TemplateRef_3_5:any;
  _NgIf_3_6:import23.Wrapper_NgIf;
  _text_4:any;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _appEl_6:import3.AppElement;
  _TemplateRef_6_5:any;
  _NgIf_6_6:import23.Wrapper_NgIf;
  _text_7:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent6,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._anchor_3 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_3 = new import3.AppElement(3,0,this,this._anchor_3);
    this._TemplateRef_3_5 = new import25.TemplateRef_(this._appEl_3,viewFactory_ContentRecordEditComponent7);
    this._NgIf_3_6 = new import23.Wrapper_NgIf(this._appEl_3.vcRef,this._TemplateRef_3_5);
    this._text_4 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_6 = new import3.AppElement(6,0,this,this._anchor_6);
    this._TemplateRef_6_5 = new import25.TemplateRef_(this._appEl_6,viewFactory_ContentRecordEditComponent8);
    this._NgIf_6_6 = new import23.Wrapper_NgIf(this._appEl_6.vcRef,this._TemplateRef_6_5);
    this._text_7 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._anchor_3,
      this._text_4,
      this._text_5,
      this._anchor_6,
      this._text_7
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.TemplateRef) && (3 === requestNodeIndex))) { return this._TemplateRef_3_5; }
    if (((token === import27.NgIf) && (3 === requestNodeIndex))) { return this._NgIf_3_6.context; }
    if (((token === import25.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import27.NgIf) && (6 === requestNodeIndex))) { return this._NgIf_6_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_3_0_0:boolean = !this.parent.parent.context.special;
    this._NgIf_3_6.check_ngIf(currVal_3_0_0,throwOnChange,false);
    this._NgIf_3_6.detectChangesInInputProps(this,this._anchor_3,throwOnChange);
    const currVal_6_0_0:any = this.parent.parent.context.special;
    this._NgIf_6_6.check_ngIf(currVal_6_0_0,throwOnChange,false);
    this._NgIf_6_6.detectChangesInInputProps(this,this._anchor_6,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordEditComponent6(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent7,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','col-xs-1 pointer switch'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'i',new import5.InlineArray8(6,'class','glyphicon glyphicon-star-empty','style','font-size:14pt','title','special'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.parent.parent.context.utils.lNavigate('admin/special/edit/0',this.parent.parent.parent.context.currentLanguage,(null as any),{queryParams: {recordUrl: this.parent.parent.parent.context.content.url}})) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentRecordEditComponent7(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent7(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent8 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent8,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','col-xs-1 pointer switch'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'i',new import5.InlineArray8(6,'class','glyphicon glyphicon-star','style','font-size:14pt','title','special'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.parent.parent.context.utils.lNavigate(('admin/special/edit/' + this.parent.parent.parent.context.special._id),this.parent.parent.parent.context.currentLanguage,(null as any))) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentRecordEditComponent8(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent8(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent9 extends import1.AppView<any> {
  _el_0:any;
  _FormArrayName_0_3:import33.Wrapper_FormArrayName;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import29.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _el_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _DefaultValueAccessor_5_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_5_4:any[];
  _FormControlName_5_5:import31.Wrapper_FormControlName;
  _NgControl_5_6:any;
  _NgControlStatus_5_7:import29.Wrapper_NgControlStatus;
  _text_6:any;
  _el_7:any;
  _el_8:any;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _appEl_10:import3.AppElement;
  _TemplateRef_10_5:any;
  _NgIf_10_6:import23.Wrapper_NgIf;
  _text_11:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent9,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray8(6,'class','input-group col-md-4','formArrayName','original_references','style','padding-right: 4px'),(null as any));
    this._FormArrayName_0_3 = new import33.Wrapper_FormArrayName((<_View_ContentRecordEditComponent5>this.parent)._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_0_4 = this._FormArrayName_0_3.context;
    this._NgControlStatusGroup_0_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n              ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_3 = import5.createRenderElement(this.renderer,this._el_2,'i',new import5.InlineArray2(2,'class','glyphicon glyphicon-education'),(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n              ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'input',new import5.InlineArray4(4,'class','form-control','type','text'),(null as any));
    this._DefaultValueAccessor_5_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_5));
    this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
    this._FormControlName_5_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_5_4);
    this._NgControl_5_6 = this._FormControlName_5_5.context;
    this._NgControlStatus_5_7 = new import29.Wrapper_NgControlStatus(this._NgControl_5_6);
    this._text_6 = this.renderer.createText(this._el_0,'\n              ',(null as any));
    this._el_7 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_8 = import5.createRenderElement(this.renderer,this._el_7,'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-remove lLink'),(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n              ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_10 = new import3.AppElement(10,0,this,this._anchor_10);
    this._TemplateRef_10_5 = new import25.TemplateRef_(this._appEl_10,viewFactory_ContentRecordEditComponent10);
    this._NgIf_10_6 = new import23.Wrapper_NgIf(this._appEl_10.vcRef,this._TemplateRef_10_5);
    this._text_11 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_5,'input',this.eventHandler(this._handle_input_5_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_5,'blur',this.eventHandler(this._handle_blur_5_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_8,'click',this.eventHandler(this._handle_click_8_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._el_8,
      this._text_9,
      this._anchor_10,
      this._text_11
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import45.DefaultValueAccessor) && (5 === requestNodeIndex))) { return this._DefaultValueAccessor_5_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_5_4; }
    if (((token === import42.FormControlName) && (5 === requestNodeIndex))) { return this._FormControlName_5_5.context; }
    if (((token === import43.NgControl) && (5 === requestNodeIndex))) { return this._NgControl_5_6; }
    if (((token === import44.NgControlStatus) && (5 === requestNodeIndex))) { return this._NgControlStatus_5_7.context; }
    if (((token === import25.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import27.NgIf) && (10 === requestNodeIndex))) { return this._NgIf_10_6.context; }
    if (((token === import47.FormArrayName) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 11)))) { return this._FormArrayName_0_3.context; }
    if (((token === import48.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 11)))) { return this._ControlContainer_0_4; }
    if (((token === import44.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 11)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = 'original_references';
    this._FormArrayName_0_3.check_name(currVal_0_0_0,throwOnChange,false);
    this._FormArrayName_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._DefaultValueAccessor_5_3.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_5_1_0:any = this.context.index;
    this._FormControlName_5_5.check_name(currVal_5_1_0,throwOnChange,false);
    this._FormControlName_5_5.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_10_0_0:any = (this.parent.parent.context.recordForm.controls.original_references.controls.length == (this.context.index + 1));
    this._NgIf_10_6.check_ngIf(currVal_10_0_0,throwOnChange,false);
    this._NgIf_10_6.detectChangesInInputProps(this,this._anchor_10,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._FormArrayName_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._DefaultValueAccessor_5_3.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._FormControlName_5_5.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_5_5.context.ngOnDestroy();
    this._FormArrayName_0_3.context.ngOnDestroy();
  }
  private _handle_input_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onChange($event.target.value)) !== false);
    return (true && pd_5_0);
  }
  private _handle_blur_5_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onTouched()) !== false);
    return (true && pd_5_0);
  }
  private _handle_click_8_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_8_0:any = ((<any>this.parent.parent.context.onRemoveOriginalReference(this.context.index)) !== false);
    return (true && pd_8_0);
  }
}
function viewFactory_ContentRecordEditComponent9(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent9(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent10 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent10,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_1 = import5.createRenderElement(this.renderer,this._el_0,'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-plus lLink'),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_1,'click',this.eventHandler(this._handle_click_1_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._el_1
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_1_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_1_0:any = ((<any>this.parent.parent.parent.context.onAddOriginalReference()) !== false);
    return (true && pd_1_0);
  }
}
function viewFactory_ContentRecordEditComponent10(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent10(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent11 extends import1.AppView<any> {
  _el_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent11,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-plus lLink'),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.parent.context.onAddOriginalReference()) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentRecordEditComponent11(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent11(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent12 extends import1.AppView<any> {
  _el_0:any;
  _FormGroupName_0_3:import33.Wrapper_FormGroupName;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import29.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _DefaultValueAccessor_6_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_6_4:any[];
  _FormControlName_6_5:import31.Wrapper_FormControlName;
  _NgControl_6_6:any;
  _NgControlStatus_6_7:import29.Wrapper_NgControlStatus;
  _text_7:any;
  _el_8:any;
  _el_9:any;
  _text_10:any;
  _anchor_11:any;
  /*private*/ _appEl_11:import3.AppElement;
  _TemplateRef_11_5:any;
  _NgIf_11_6:import23.Wrapper_NgIf;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _DefaultValueAccessor_22_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_22_4:any[];
  _FormControlName_22_5:import31.Wrapper_FormControlName;
  _NgControl_22_6:any;
  _NgControlStatus_22_7:import29.Wrapper_NgControlStatus;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _el_31:any;
  _DefaultValueAccessor_31_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_31_4:any[];
  _FormControlName_31_5:import31.Wrapper_FormControlName;
  _NgControl_31_6:any;
  _NgControlStatus_31_7:import29.Wrapper_NgControlStatus;
  _text_32:any;
  _el_33:any;
  /*private*/ _appEl_33:import3.AppElement;
  _SearchAutocompleteComponent_33_4:import53.Wrapper_SearchAutocompleteComponent;
  _text_34:any;
  _text_35:any;
  _text_36:any;
  _el_37:any;
  _text_38:any;
  _el_39:any;
  _text_40:any;
  _text_41:any;
  _el_42:any;
  _DefaultValueAccessor_42_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_42_4:any[];
  _FormControlName_42_5:import31.Wrapper_FormControlName;
  _NgControl_42_6:any;
  _NgControlStatus_42_7:import29.Wrapper_NgControlStatus;
  _text_43:any;
  _el_44:any;
  /*private*/ _appEl_44:import3.AppElement;
  _SearchAutocompleteComponent_44_4:import53.Wrapper_SearchAutocompleteComponent;
  _text_45:any;
  _text_46:any;
  _text_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _el_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _text_55:any;
  _el_56:any;
  _DefaultValueAccessor_56_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_56_4:any[];
  _FormControlName_56_5:import31.Wrapper_FormControlName;
  _NgControl_56_6:any;
  _NgControlStatus_56_7:import29.Wrapper_NgControlStatus;
  _text_57:any;
  _el_58:any;
  /*private*/ _appEl_58:import3.AppElement;
  _SearchAutocompleteComponent_58_4:import53.Wrapper_SearchAutocompleteComponent;
  _text_59:any;
  _text_60:any;
  _text_61:any;
  _text_62:any;
  _el_63:any;
  _text_64:any;
  _anchor_65:any;
  /*private*/ _appEl_65:import3.AppElement;
  _TemplateRef_65_5:any;
  _NgFor_65_6:import37.Wrapper_NgFor;
  _text_66:any;
  _anchor_67:any;
  /*private*/ _appEl_67:import3.AppElement;
  _TemplateRef_67_5:any;
  _NgIf_67_6:import23.Wrapper_NgIf;
  _text_68:any;
  _text_69:any;
  /*private*/ _expr_113:any;
  /*private*/ _expr_114:any;
  /*private*/ _expr_115:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent12,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_113 = import8.UNINITIALIZED;
    this._expr_114 = import8.UNINITIALIZED;
    this._expr_115 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','form-group'),(null as any));
    this._FormGroupName_0_3 = new import33.Wrapper_FormGroupName((<_View_ContentRecordEditComponent5>this.parent)._ControlContainer_113_4,(null as any),(null as any));
    this._ControlContainer_0_4 = this._FormGroupName_0_3.context;
    this._NgControlStatusGroup_0_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','block'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','collapse input-group col-xs-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._el_6 = import5.createRenderElement(this.renderer,this._el_4,'input',new import5.InlineArray8(8,'class','form-control','formControlName','title','style','font-weight:bold','type','text'),(null as any));
    this._DefaultValueAccessor_6_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_6));
    this._NG_VALUE_ACCESSOR_6_4 = [this._DefaultValueAccessor_6_3.context];
    this._FormControlName_6_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_6_4);
    this._NgControl_6_6 = this._FormControlName_6_5.context;
    this._NgControlStatus_6_7 = new import29.Wrapper_NgControlStatus(this._NgControl_6_6);
    this._text_7 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._el_8 = import5.createRenderElement(this.renderer,this._el_4,'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_9 = import5.createRenderElement(this.renderer,this._el_8,'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-remove lLink'),(null as any));
    this._text_10 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._anchor_11 = this.renderer.createTemplateAnchor(this._el_4,(null as any));
    this._appEl_11 = new import3.AppElement(11,4,this,this._anchor_11);
    this._TemplateRef_11_5 = new import25.TemplateRef_(this._appEl_11,viewFactory_ContentRecordEditComponent13);
    this._NgIf_11_6 = new import23.Wrapper_NgIf(this._appEl_11.vcRef,this._TemplateRef_11_5);
    this._text_12 = this.renderer.createText(this._el_4,'\n              ',(null as any));
    this._text_13 = this.renderer.createText(this._el_2,'\n          ',(null as any));
    this._text_14 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','block form-inline'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n              ',(null as any));
    this._el_17 = import5.createRenderElement(this.renderer,this._el_15,'div',new import5.InlineArray2(2,'class','input-group col-md-3'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                ',(null as any));
    this._el_19 = import5.createRenderElement(this.renderer,this._el_17,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_20 = import5.createRenderElement(this.renderer,this._el_19,'i',new import5.InlineArray2(2,'class','fa fa-calendar'),(null as any));
    this._text_21 = this.renderer.createText(this._el_17,'\n                ',(null as any));
    this._el_22 = import5.createRenderElement(this.renderer,this._el_17,'input',new import5.InlineArray8(6,'class','form-control date-mask','formControlName','date','type','text'),(null as any));
    this._DefaultValueAccessor_22_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_22));
    this._NG_VALUE_ACCESSOR_22_4 = [this._DefaultValueAccessor_22_3.context];
    this._FormControlName_22_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_22_4);
    this._NgControl_22_6 = this._FormControlName_22_5.context;
    this._NgControlStatus_22_7 = new import29.Wrapper_NgControlStatus(this._NgControl_22_6);
    this._text_23 = this.renderer.createText(this._el_17,'\n              ',(null as any));
    this._text_24 = this.renderer.createText(this._el_15,'\n              ',(null as any));
    this._el_25 = import5.createRenderElement(this.renderer,this._el_15,'div',new import5.InlineArray2(2,'class','input-group col-md-4'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'\n                ',(null as any));
    this._el_27 = import5.createRenderElement(this.renderer,this._el_25,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'C',(null as any));
    this._text_29 = this.renderer.createText(this._el_25,'\n                ',(null as any));
    this._text_30 = this.renderer.createText(this._el_25,'\n                ',(null as any));
    this._el_31 = import5.createRenderElement(this.renderer,this._el_25,'input',new import5.InlineArray8(6,'class','form-control','formControlName','composer','type','text'),(null as any));
    this._DefaultValueAccessor_31_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_31));
    this._NG_VALUE_ACCESSOR_31_4 = [this._DefaultValueAccessor_31_3.context];
    this._FormControlName_31_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_31_4);
    this._NgControl_31_6 = this._FormControlName_31_5.context;
    this._NgControlStatus_31_7 = new import29.Wrapper_NgControlStatus(this._NgControl_31_6);
    this._text_32 = this.renderer.createText(this._el_25,'\n                 ',(null as any));
    this._el_33 = import5.createRenderElement(this.renderer,this._el_25,'search-autocomplete',new import5.InlineArray2(2,'esType','composer'),(null as any));
    this._appEl_33 = new import3.AppElement(33,25,this,this._el_33);
    var compView_33:any = import53.viewFactory_SearchAutocompleteComponent0(this.viewUtils,this.injector(33),this._appEl_33);
    this._SearchAutocompleteComponent_33_4 = new import53.Wrapper_SearchAutocompleteComponent(new import13.ElementRef(this._el_33),this.parent.parent.parentInjector.get(import14.SearchService),this.parent.parent.parentInjector.get(import15.UtilsService));
    this._appEl_33.initComponent(this._SearchAutocompleteComponent_33_4.context,([] as any[]),compView_33);
    this._text_34 = this.renderer.createText((null as any),'\n                ',(null as any));
    compView_33.create(this._SearchAutocompleteComponent_33_4.context,([] as any[]),(null as any));
    this._text_35 = this.renderer.createText(this._el_25,' \n              ',(null as any));
    this._text_36 = this.renderer.createText(this._el_15,'\n              ',(null as any));
    this._el_37 = import5.createRenderElement(this.renderer,this._el_15,'div',new import5.InlineArray2(2,'class','input-group col-md-4'),(null as any));
    this._text_38 = this.renderer.createText(this._el_37,'\n                ',(null as any));
    this._el_39 = import5.createRenderElement(this.renderer,this._el_37,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._text_40 = this.renderer.createText(this._el_39,'C.O',(null as any));
    this._text_41 = this.renderer.createText(this._el_37,'\n                ',(null as any));
    this._el_42 = import5.createRenderElement(this.renderer,this._el_37,'input',new import5.InlineArray8(6,'class','form-control','formControlName','conductor','type','text'),(null as any));
    this._DefaultValueAccessor_42_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_42));
    this._NG_VALUE_ACCESSOR_42_4 = [this._DefaultValueAccessor_42_3.context];
    this._FormControlName_42_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_42_4);
    this._NgControl_42_6 = this._FormControlName_42_5.context;
    this._NgControlStatus_42_7 = new import29.Wrapper_NgControlStatus(this._NgControl_42_6);
    this._text_43 = this.renderer.createText(this._el_37,'\n                 ',(null as any));
    this._el_44 = import5.createRenderElement(this.renderer,this._el_37,'search-autocomplete',new import5.InlineArray2(2,'esType','conductor'),(null as any));
    this._appEl_44 = new import3.AppElement(44,37,this,this._el_44);
    var compView_44:any = import53.viewFactory_SearchAutocompleteComponent0(this.viewUtils,this.injector(44),this._appEl_44);
    this._SearchAutocompleteComponent_44_4 = new import53.Wrapper_SearchAutocompleteComponent(new import13.ElementRef(this._el_44),this.parent.parent.parentInjector.get(import14.SearchService),this.parent.parent.parentInjector.get(import15.UtilsService));
    this._appEl_44.initComponent(this._SearchAutocompleteComponent_44_4.context,([] as any[]),compView_44);
    this._text_45 = this.renderer.createText((null as any),'\n                ',(null as any));
    compView_44.create(this._SearchAutocompleteComponent_44_4.context,([] as any[]),(null as any));
    this._text_46 = this.renderer.createText(this._el_37,' \n              ',(null as any));
    this._text_47 = this.renderer.createText(this._el_15,'\n          ',(null as any));
    this._text_48 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._el_49 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','form-inline'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'\n              ',(null as any));
    this._el_51 = import5.createRenderElement(this.renderer,this._el_49,'div',new import5.InlineArray4(4,'class','col-md-6 input-group','style','padding-right: 3px'),(null as any));
    this._text_52 = this.renderer.createText(this._el_51,'\n                ',(null as any));
    this._el_53 = import5.createRenderElement(this.renderer,this._el_51,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._text_54 = this.renderer.createText(this._el_53,'O',(null as any));
    this._text_55 = this.renderer.createText(this._el_51,'\n                ',(null as any));
    this._el_56 = import5.createRenderElement(this.renderer,this._el_51,'input',new import5.InlineArray8(6,'class','form-control','formControlName','orchestra','type','text'),(null as any));
    this._DefaultValueAccessor_56_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_56));
    this._NG_VALUE_ACCESSOR_56_4 = [this._DefaultValueAccessor_56_3.context];
    this._FormControlName_56_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_56_4);
    this._NgControl_56_6 = this._FormControlName_56_5.context;
    this._NgControlStatus_56_7 = new import29.Wrapper_NgControlStatus(this._NgControl_56_6);
    this._text_57 = this.renderer.createText(this._el_51,'\n                 ',(null as any));
    this._el_58 = import5.createRenderElement(this.renderer,this._el_51,'search-autocomplete',new import5.InlineArray2(2,'esType','orchestra'),(null as any));
    this._appEl_58 = new import3.AppElement(58,51,this,this._el_58);
    var compView_58:any = import53.viewFactory_SearchAutocompleteComponent0(this.viewUtils,this.injector(58),this._appEl_58);
    this._SearchAutocompleteComponent_58_4 = new import53.Wrapper_SearchAutocompleteComponent(new import13.ElementRef(this._el_58),this.parent.parent.parentInjector.get(import14.SearchService),this.parent.parent.parentInjector.get(import15.UtilsService));
    this._appEl_58.initComponent(this._SearchAutocompleteComponent_58_4.context,([] as any[]),compView_58);
    this._text_59 = this.renderer.createText((null as any),'\n                ',(null as any));
    compView_58.create(this._SearchAutocompleteComponent_58_4.context,([] as any[]),(null as any));
    this._text_60 = this.renderer.createText(this._el_51,' \n              ',(null as any));
    this._text_61 = this.renderer.createText(this._el_49,'\n          ',(null as any));
    this._text_62 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._el_63 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','form-inline'),(null as any));
    this._text_64 = this.renderer.createText(this._el_63,'\n              ',(null as any));
    this._anchor_65 = this.renderer.createTemplateAnchor(this._el_63,(null as any));
    this._appEl_65 = new import3.AppElement(65,63,this,this._anchor_65);
    this._TemplateRef_65_5 = new import25.TemplateRef_(this._appEl_65,viewFactory_ContentRecordEditComponent14);
    this._NgFor_65_6 = new import37.Wrapper_NgFor(this._appEl_65.vcRef,this._TemplateRef_65_5,this.parent.parent.parentInjector.get(import39.IterableDiffers),this.parent.parent.ref);
    this._text_66 = this.renderer.createText(this._el_63,'\n              ',(null as any));
    this._anchor_67 = this.renderer.createTemplateAnchor(this._el_63,(null as any));
    this._appEl_67 = new import3.AppElement(67,63,this,this._anchor_67);
    this._TemplateRef_67_5 = new import25.TemplateRef_(this._appEl_67,viewFactory_ContentRecordEditComponent16);
    this._NgIf_67_6 = new import23.Wrapper_NgIf(this._appEl_67.vcRef,this._TemplateRef_67_5);
    this._text_68 = this.renderer.createText(this._el_63,'\n          ',(null as any));
    this._text_69 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_6,'input',this.eventHandler(this._handle_input_6_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_6,'blur',this.eventHandler(this._handle_blur_6_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_9,'click',this.eventHandler(this._handle_click_9_0.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_22,'input',this.eventHandler(this._handle_input_22_0.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_22,'blur',this.eventHandler(this._handle_blur_22_1.bind(this)));
    var disposable_5:Function = this.renderer.listen(this._el_31,'keyup',this.eventHandler(this._handle_keyup_31_0.bind(this)));
    var disposable_6:Function = this.renderer.listen(this._el_31,'input',this.eventHandler(this._handle_input_31_1.bind(this)));
    var disposable_7:Function = this.renderer.listen(this._el_31,'blur',this.eventHandler(this._handle_blur_31_2.bind(this)));
    var disposable_8:Function = this.renderer.listen(this._el_42,'keyup',this.eventHandler(this._handle_keyup_42_0.bind(this)));
    var disposable_9:Function = this.renderer.listen(this._el_42,'input',this.eventHandler(this._handle_input_42_1.bind(this)));
    var disposable_10:Function = this.renderer.listen(this._el_42,'blur',this.eventHandler(this._handle_blur_42_2.bind(this)));
    var disposable_11:Function = this.renderer.listen(this._el_56,'keyup',this.eventHandler(this._handle_keyup_56_0.bind(this)));
    var disposable_12:Function = this.renderer.listen(this._el_56,'input',this.eventHandler(this._handle_input_56_1.bind(this)));
    var disposable_13:Function = this.renderer.listen(this._el_56,'blur',this.eventHandler(this._handle_blur_56_2.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._el_9,
      this._text_10,
      this._anchor_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._text_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._el_33,
      this._text_34,
      this._text_35,
      this._text_36,
      this._el_37,
      this._text_38,
      this._el_39,
      this._text_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._text_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._el_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._text_55,
      this._el_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._text_60,
      this._text_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._anchor_65,
      this._text_66,
      this._anchor_67,
      this._text_68,
      this._text_69
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8,
      disposable_9,
      disposable_10,
      disposable_11,
      disposable_12,
      disposable_13
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import45.DefaultValueAccessor) && (6 === requestNodeIndex))) { return this._DefaultValueAccessor_6_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (6 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_6_4; }
    if (((token === import42.FormControlName) && (6 === requestNodeIndex))) { return this._FormControlName_6_5.context; }
    if (((token === import43.NgControl) && (6 === requestNodeIndex))) { return this._NgControl_6_6; }
    if (((token === import44.NgControlStatus) && (6 === requestNodeIndex))) { return this._NgControlStatus_6_7.context; }
    if (((token === import25.TemplateRef) && (11 === requestNodeIndex))) { return this._TemplateRef_11_5; }
    if (((token === import27.NgIf) && (11 === requestNodeIndex))) { return this._NgIf_11_6.context; }
    if (((token === import45.DefaultValueAccessor) && (22 === requestNodeIndex))) { return this._DefaultValueAccessor_22_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (22 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_22_4; }
    if (((token === import42.FormControlName) && (22 === requestNodeIndex))) { return this._FormControlName_22_5.context; }
    if (((token === import43.NgControl) && (22 === requestNodeIndex))) { return this._NgControl_22_6; }
    if (((token === import44.NgControlStatus) && (22 === requestNodeIndex))) { return this._NgControlStatus_22_7.context; }
    if (((token === import45.DefaultValueAccessor) && (31 === requestNodeIndex))) { return this._DefaultValueAccessor_31_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (31 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_31_4; }
    if (((token === import42.FormControlName) && (31 === requestNodeIndex))) { return this._FormControlName_31_5.context; }
    if (((token === import43.NgControl) && (31 === requestNodeIndex))) { return this._NgControl_31_6; }
    if (((token === import44.NgControlStatus) && (31 === requestNodeIndex))) { return this._NgControlStatus_31_7.context; }
    if (((token === import54.SearchAutocompleteComponent) && ((33 <= requestNodeIndex) && (requestNodeIndex <= 34)))) { return this._SearchAutocompleteComponent_33_4.context; }
    if (((token === import45.DefaultValueAccessor) && (42 === requestNodeIndex))) { return this._DefaultValueAccessor_42_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (42 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_42_4; }
    if (((token === import42.FormControlName) && (42 === requestNodeIndex))) { return this._FormControlName_42_5.context; }
    if (((token === import43.NgControl) && (42 === requestNodeIndex))) { return this._NgControl_42_6; }
    if (((token === import44.NgControlStatus) && (42 === requestNodeIndex))) { return this._NgControlStatus_42_7.context; }
    if (((token === import54.SearchAutocompleteComponent) && ((44 <= requestNodeIndex) && (requestNodeIndex <= 45)))) { return this._SearchAutocompleteComponent_44_4.context; }
    if (((token === import45.DefaultValueAccessor) && (56 === requestNodeIndex))) { return this._DefaultValueAccessor_56_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (56 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_56_4; }
    if (((token === import42.FormControlName) && (56 === requestNodeIndex))) { return this._FormControlName_56_5.context; }
    if (((token === import43.NgControl) && (56 === requestNodeIndex))) { return this._NgControl_56_6; }
    if (((token === import44.NgControlStatus) && (56 === requestNodeIndex))) { return this._NgControlStatus_56_7.context; }
    if (((token === import54.SearchAutocompleteComponent) && ((58 <= requestNodeIndex) && (requestNodeIndex <= 59)))) { return this._SearchAutocompleteComponent_58_4.context; }
    if (((token === import25.TemplateRef) && (65 === requestNodeIndex))) { return this._TemplateRef_65_5; }
    if (((token === import51.NgFor) && (65 === requestNodeIndex))) { return this._NgFor_65_6.context; }
    if (((token === import25.TemplateRef) && (67 === requestNodeIndex))) { return this._TemplateRef_67_5; }
    if (((token === import27.NgIf) && (67 === requestNodeIndex))) { return this._NgIf_67_6.context; }
    if (((token === import47.FormGroupName) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) { return this._FormGroupName_0_3.context; }
    if (((token === import48.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) { return this._ControlContainer_0_4; }
    if (((token === import44.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.index;
    this._FormGroupName_0_3.check_name(currVal_0_0_0,throwOnChange,false);
    this._FormGroupName_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._DefaultValueAccessor_6_3.detectChangesInInputProps(this,this._el_6,throwOnChange);
    const currVal_6_1_0:any = 'title';
    this._FormControlName_6_5.check_name(currVal_6_1_0,throwOnChange,false);
    this._FormControlName_6_5.detectChangesInInputProps(this,this._el_6,throwOnChange);
    this._NgControlStatus_6_7.detectChangesInInputProps(this,this._el_6,throwOnChange);
    const currVal_11_0_0:any = (this.parent.parent.context.recordForm.get('music_pieces').controls.length == (this.context.index + 1));
    this._NgIf_11_6.check_ngIf(currVal_11_0_0,throwOnChange,false);
    this._NgIf_11_6.detectChangesInInputProps(this,this._anchor_11,throwOnChange);
    this._DefaultValueAccessor_22_3.detectChangesInInputProps(this,this._el_22,throwOnChange);
    const currVal_22_1_0:any = 'date';
    this._FormControlName_22_5.check_name(currVal_22_1_0,throwOnChange,false);
    this._FormControlName_22_5.detectChangesInInputProps(this,this._el_22,throwOnChange);
    this._NgControlStatus_22_7.detectChangesInInputProps(this,this._el_22,throwOnChange);
    this._DefaultValueAccessor_31_3.detectChangesInInputProps(this,this._el_31,throwOnChange);
    const currVal_31_1_0:any = 'composer';
    this._FormControlName_31_5.check_name(currVal_31_1_0,throwOnChange,false);
    this._FormControlName_31_5.detectChangesInInputProps(this,this._el_31,throwOnChange);
    this._NgControlStatus_31_7.detectChangesInInputProps(this,this._el_31,throwOnChange);
    const currVal_33_0_0:any = this.parent.parent.context.recordForm;
    this._SearchAutocompleteComponent_33_4.check_form(currVal_33_0_0,throwOnChange,false);
    const currVal_33_0_1:any = import5.interpolate(1,'music_pieces.',this.context.index,'.composer');
    this._SearchAutocompleteComponent_33_4.check_formPath(currVal_33_0_1,throwOnChange,false);
    const currVal_33_0_2:any = import5.interpolate(1,'composer',this.context.index,'');
    this._SearchAutocompleteComponent_33_4.check_target(currVal_33_0_2,throwOnChange,false);
    const currVal_33_0_3:any = this.parent.parent.context.inputFocus;
    this._SearchAutocompleteComponent_33_4.check_input(currVal_33_0_3,throwOnChange,false);
    const currVal_33_0_4:any = 'composer';
    this._SearchAutocompleteComponent_33_4.check_esType(currVal_33_0_4,throwOnChange,false);
    this._SearchAutocompleteComponent_33_4.detectChangesInInputProps(this,this._el_33,throwOnChange);
    this._DefaultValueAccessor_42_3.detectChangesInInputProps(this,this._el_42,throwOnChange);
    const currVal_42_1_0:any = 'conductor';
    this._FormControlName_42_5.check_name(currVal_42_1_0,throwOnChange,false);
    this._FormControlName_42_5.detectChangesInInputProps(this,this._el_42,throwOnChange);
    this._NgControlStatus_42_7.detectChangesInInputProps(this,this._el_42,throwOnChange);
    const currVal_44_0_0:any = this.parent.parent.context.recordForm;
    this._SearchAutocompleteComponent_44_4.check_form(currVal_44_0_0,throwOnChange,false);
    const currVal_44_0_1:any = import5.interpolate(1,'music_pieces.',this.context.index,'.conductor');
    this._SearchAutocompleteComponent_44_4.check_formPath(currVal_44_0_1,throwOnChange,false);
    const currVal_44_0_2:any = import5.interpolate(1,'conductor',this.context.index,'');
    this._SearchAutocompleteComponent_44_4.check_target(currVal_44_0_2,throwOnChange,false);
    const currVal_44_0_3:any = this.parent.parent.context.inputFocus;
    this._SearchAutocompleteComponent_44_4.check_input(currVal_44_0_3,throwOnChange,false);
    const currVal_44_0_4:any = 'conductor';
    this._SearchAutocompleteComponent_44_4.check_esType(currVal_44_0_4,throwOnChange,false);
    this._SearchAutocompleteComponent_44_4.detectChangesInInputProps(this,this._el_44,throwOnChange);
    this._DefaultValueAccessor_56_3.detectChangesInInputProps(this,this._el_56,throwOnChange);
    const currVal_56_1_0:any = 'orchestra';
    this._FormControlName_56_5.check_name(currVal_56_1_0,throwOnChange,false);
    this._FormControlName_56_5.detectChangesInInputProps(this,this._el_56,throwOnChange);
    this._NgControlStatus_56_7.detectChangesInInputProps(this,this._el_56,throwOnChange);
    const currVal_58_0_0:any = this.parent.parent.context.recordForm;
    this._SearchAutocompleteComponent_58_4.check_form(currVal_58_0_0,throwOnChange,false);
    const currVal_58_0_1:any = import5.interpolate(1,'music_pieces.',this.context.index,'.orchestra');
    this._SearchAutocompleteComponent_58_4.check_formPath(currVal_58_0_1,throwOnChange,false);
    const currVal_58_0_2:any = import5.interpolate(1,'orchestra',this.context.index,'');
    this._SearchAutocompleteComponent_58_4.check_target(currVal_58_0_2,throwOnChange,false);
    const currVal_58_0_3:any = this.parent.parent.context.inputFocus;
    this._SearchAutocompleteComponent_58_4.check_input(currVal_58_0_3,throwOnChange,false);
    const currVal_58_0_4:any = 'orchestra';
    this._SearchAutocompleteComponent_58_4.check_esType(currVal_58_0_4,throwOnChange,false);
    this._SearchAutocompleteComponent_58_4.detectChangesInInputProps(this,this._el_58,throwOnChange);
    const currVal_65_0_0:any = this.parent.parent.context.recordForm.get('music_pieces').at(this.context.index).get('soloists').controls;
    this._NgFor_65_6.check_ngForOf(currVal_65_0_0,throwOnChange,false);
    this._NgFor_65_6.detectChangesInInputProps(this,this._anchor_65,throwOnChange);
    const currVal_67_0_0:any = (this.parent.parent.context.recordForm.get('music_pieces').at(this.context.index).get('soloists').controls == 0);
    this._NgIf_67_6.check_ngIf(currVal_67_0_0,throwOnChange,false);
    this._NgIf_67_6.detectChangesInInputProps(this,this._anchor_67,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._FormGroupName_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._DefaultValueAccessor_6_3.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._FormControlName_6_5.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._NgControlStatus_6_7.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._DefaultValueAccessor_22_3.detectChangesInHostProps(this,this._el_22,throwOnChange);
    this._FormControlName_22_5.detectChangesInHostProps(this,this._el_22,throwOnChange);
    this._NgControlStatus_22_7.detectChangesInHostProps(this,this._el_22,throwOnChange);
    const currVal_113:any = import5.interpolate(1,'composer',this.context.index,'');
    if (import5.checkBinding(throwOnChange,this._expr_113,currVal_113)) {
      this.renderer.setElementProperty(this._el_31,'id',currVal_113);
      this._expr_113 = currVal_113;
    }
    this._DefaultValueAccessor_31_3.detectChangesInHostProps(this,this._el_31,throwOnChange);
    this._FormControlName_31_5.detectChangesInHostProps(this,this._el_31,throwOnChange);
    this._NgControlStatus_31_7.detectChangesInHostProps(this,this._el_31,throwOnChange);
    this._SearchAutocompleteComponent_33_4.detectChangesInHostProps(this,this._el_33,throwOnChange);
    const currVal_114:any = import5.interpolate(1,'conductor',this.context.index,'');
    if (import5.checkBinding(throwOnChange,this._expr_114,currVal_114)) {
      this.renderer.setElementProperty(this._el_42,'id',currVal_114);
      this._expr_114 = currVal_114;
    }
    this._DefaultValueAccessor_42_3.detectChangesInHostProps(this,this._el_42,throwOnChange);
    this._FormControlName_42_5.detectChangesInHostProps(this,this._el_42,throwOnChange);
    this._NgControlStatus_42_7.detectChangesInHostProps(this,this._el_42,throwOnChange);
    this._SearchAutocompleteComponent_44_4.detectChangesInHostProps(this,this._el_44,throwOnChange);
    const currVal_115:any = import5.interpolate(1,'orchestra',this.context.index,'');
    if (import5.checkBinding(throwOnChange,this._expr_115,currVal_115)) {
      this.renderer.setElementProperty(this._el_56,'id',currVal_115);
      this._expr_115 = currVal_115;
    }
    this._DefaultValueAccessor_56_3.detectChangesInHostProps(this,this._el_56,throwOnChange);
    this._FormControlName_56_5.detectChangesInHostProps(this,this._el_56,throwOnChange);
    this._NgControlStatus_56_7.detectChangesInHostProps(this,this._el_56,throwOnChange);
    this._SearchAutocompleteComponent_58_4.detectChangesInHostProps(this,this._el_58,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_6_5.context.ngOnDestroy();
    this._FormControlName_22_5.context.ngOnDestroy();
    this._FormControlName_31_5.context.ngOnDestroy();
    this._FormControlName_42_5.context.ngOnDestroy();
    this._FormControlName_56_5.context.ngOnDestroy();
  }
  private _handle_input_6_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this._DefaultValueAccessor_6_3.context.onChange($event.target.value)) !== false);
    return (true && pd_6_0);
  }
  private _handle_blur_6_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this._DefaultValueAccessor_6_3.context.onTouched()) !== false);
    return (true && pd_6_0);
  }
  private _handle_click_9_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_9_0:any = ((<any>this.parent.parent.context.onRemoveMusicPiece(this.context.index)) !== false);
    return (true && pd_9_0);
  }
  private _handle_input_22_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_22_0:any = ((<any>this._DefaultValueAccessor_22_3.context.onChange($event.target.value)) !== false);
    return (true && pd_22_0);
  }
  private _handle_blur_22_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_22_0:any = ((<any>this._DefaultValueAccessor_22_3.context.onTouched()) !== false);
    return (true && pd_22_0);
  }
  private _handle_keyup_31_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_31_0:any = ((<any>this.parent.parent.context.onInputChange('composer',$event)) !== false);
    return (true && pd_31_0);
  }
  private _handle_input_31_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_31_0:any = ((<any>this._DefaultValueAccessor_31_3.context.onChange($event.target.value)) !== false);
    return (true && pd_31_0);
  }
  private _handle_blur_31_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_31_0:any = ((<any>this._DefaultValueAccessor_31_3.context.onTouched()) !== false);
    return (true && pd_31_0);
  }
  private _handle_keyup_42_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_42_0:any = ((<any>this.parent.parent.context.onInputChange('conductor',$event)) !== false);
    return (true && pd_42_0);
  }
  private _handle_input_42_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_42_0:any = ((<any>this._DefaultValueAccessor_42_3.context.onChange($event.target.value)) !== false);
    return (true && pd_42_0);
  }
  private _handle_blur_42_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_42_0:any = ((<any>this._DefaultValueAccessor_42_3.context.onTouched()) !== false);
    return (true && pd_42_0);
  }
  private _handle_keyup_56_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_56_0:any = ((<any>this.parent.parent.context.onInputChange('orchestra',$event)) !== false);
    return (true && pd_56_0);
  }
  private _handle_input_56_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_56_0:any = ((<any>this._DefaultValueAccessor_56_3.context.onChange($event.target.value)) !== false);
    return (true && pd_56_0);
  }
  private _handle_blur_56_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_56_0:any = ((<any>this._DefaultValueAccessor_56_3.context.onTouched()) !== false);
    return (true && pd_56_0);
  }
}
function viewFactory_ContentRecordEditComponent12(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent12(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent13 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent13,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_1 = import5.createRenderElement(this.renderer,this._el_0,'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-plus lLink'),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_1,'click',this.eventHandler(this._handle_click_1_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._el_1
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_1_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_1_0:any = ((<any>this.parent.parent.parent.context.onAddMusicPiece()) !== false);
    return (true && pd_1_0);
  }
}
function viewFactory_ContentRecordEditComponent13(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent13(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent14 extends import1.AppView<any> {
  _el_0:any;
  _FormArrayName_0_3:import33.Wrapper_FormArrayName;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import29.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _el_2:any;
  _FormGroupName_2_3:import33.Wrapper_FormGroupName;
  _ControlContainer_2_4:any;
  _NgControlStatusGroup_2_5:import29.Wrapper_NgControlStatusGroup;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _DefaultValueAccessor_9_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_9_4:any[];
  _FormControlName_9_5:import31.Wrapper_FormControlName;
  _NgControl_9_6:any;
  _NgControlStatus_9_7:import29.Wrapper_NgControlStatus;
  _text_10:any;
  _el_11:any;
  /*private*/ _appEl_11:import3.AppElement;
  _SearchAutocompleteComponent_11_4:import53.Wrapper_SearchAutocompleteComponent;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _DefaultValueAccessor_20_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_20_4:any[];
  _FormControlName_20_5:import31.Wrapper_FormControlName;
  _NgControl_20_6:any;
  _NgControlStatus_20_7:import29.Wrapper_NgControlStatus;
  _text_21:any;
  _el_22:any;
  /*private*/ _appEl_22:import3.AppElement;
  _SearchAutocompleteComponent_22_4:import53.Wrapper_SearchAutocompleteComponent;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _el_26:any;
  _text_27:any;
  _anchor_28:any;
  /*private*/ _appEl_28:import3.AppElement;
  _TemplateRef_28_5:any;
  _NgIf_28_6:import23.Wrapper_NgIf;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  /*private*/ _expr_55:any;
  /*private*/ _expr_56:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent14,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_55 = import8.UNINITIALIZED;
    this._expr_56 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'formArrayName','soloists'),(null as any));
    this._FormArrayName_0_3 = new import33.Wrapper_FormArrayName((<_View_ContentRecordEditComponent12>this.parent)._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_0_4 = this._FormArrayName_0_3.context;
    this._NgControlStatusGroup_0_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','form-inline'),(null as any));
    this._FormGroupName_2_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_2_4 = this._FormGroupName_2_3.context;
    this._NgControlStatusGroup_2_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_2_4);
    this._text_3 = this.renderer.createText(this._el_2,'\n                  ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','input-group col-md-5'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_6 = import5.createRenderElement(this.renderer,this._el_4,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'S',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_9 = import5.createRenderElement(this.renderer,this._el_4,'input',new import5.InlineArray8(6,'class','form-control','formControlName','name','type','text'),(null as any));
    this._DefaultValueAccessor_9_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_9));
    this._NG_VALUE_ACCESSOR_9_4 = [this._DefaultValueAccessor_9_3.context];
    this._FormControlName_9_5 = new import31.Wrapper_FormControlName(this._ControlContainer_2_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_9_4);
    this._NgControl_9_6 = this._FormControlName_9_5.context;
    this._NgControlStatus_9_7 = new import29.Wrapper_NgControlStatus(this._NgControl_9_6);
    this._text_10 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_11 = import5.createRenderElement(this.renderer,this._el_4,'search-autocomplete',new import5.InlineArray2(2,'esType','soloist'),(null as any));
    this._appEl_11 = new import3.AppElement(11,4,this,this._el_11);
    var compView_11:any = import53.viewFactory_SearchAutocompleteComponent0(this.viewUtils,this.injector(11),this._appEl_11);
    this._SearchAutocompleteComponent_11_4 = new import53.Wrapper_SearchAutocompleteComponent(new import13.ElementRef(this._el_11),this.parent.parent.parent.parentInjector.get(import14.SearchService),this.parent.parent.parent.parentInjector.get(import15.UtilsService));
    this._appEl_11.initComponent(this._SearchAutocompleteComponent_11_4.context,([] as any[]),compView_11);
    this._text_12 = this.renderer.createText((null as any),'\n                    ',(null as any));
    compView_11.create(this._SearchAutocompleteComponent_11_4.context,([] as any[]),(null as any));
    this._text_13 = this.renderer.createText(this._el_4,'\n                  ',(null as any));
    this._text_14 = this.renderer.createText(this._el_2,'\n                  ',(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','input-group col-md-6'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                    ',(null as any));
    this._el_17 = import5.createRenderElement(this.renderer,this._el_15,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'I',(null as any));
    this._text_19 = this.renderer.createText(this._el_15,'\n                    ',(null as any));
    this._el_20 = import5.createRenderElement(this.renderer,this._el_15,'input',new import5.InlineArray8(6,'class','form-control','formControlName','instrument','type','text'),(null as any));
    this._DefaultValueAccessor_20_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_20));
    this._NG_VALUE_ACCESSOR_20_4 = [this._DefaultValueAccessor_20_3.context];
    this._FormControlName_20_5 = new import31.Wrapper_FormControlName(this._ControlContainer_2_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_20_4);
    this._NgControl_20_6 = this._FormControlName_20_5.context;
    this._NgControlStatus_20_7 = new import29.Wrapper_NgControlStatus(this._NgControl_20_6);
    this._text_21 = this.renderer.createText(this._el_15,'\n                    ',(null as any));
    this._el_22 = import5.createRenderElement(this.renderer,this._el_15,'search-autocomplete',new import5.InlineArray2(2,'esType','instrument'),(null as any));
    this._appEl_22 = new import3.AppElement(22,15,this,this._el_22);
    var compView_22:any = import53.viewFactory_SearchAutocompleteComponent0(this.viewUtils,this.injector(22),this._appEl_22);
    this._SearchAutocompleteComponent_22_4 = new import53.Wrapper_SearchAutocompleteComponent(new import13.ElementRef(this._el_22),this.parent.parent.parent.parentInjector.get(import14.SearchService),this.parent.parent.parent.parentInjector.get(import15.UtilsService));
    this._appEl_22.initComponent(this._SearchAutocompleteComponent_22_4.context,([] as any[]),compView_22);
    this._text_23 = this.renderer.createText((null as any),'\n                    ',(null as any));
    compView_22.create(this._SearchAutocompleteComponent_22_4.context,([] as any[]),(null as any));
    this._text_24 = this.renderer.createText(this._el_15,'\n                    ',(null as any));
    this._el_25 = import5.createRenderElement(this.renderer,this._el_15,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_26 = import5.createRenderElement(this.renderer,this._el_25,'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-remove lLink'),(null as any));
    this._text_27 = this.renderer.createText(this._el_15,'\n                    ',(null as any));
    this._anchor_28 = this.renderer.createTemplateAnchor(this._el_15,(null as any));
    this._appEl_28 = new import3.AppElement(28,15,this,this._anchor_28);
    this._TemplateRef_28_5 = new import25.TemplateRef_(this._appEl_28,viewFactory_ContentRecordEditComponent15);
    this._NgIf_28_6 = new import23.Wrapper_NgIf(this._appEl_28.vcRef,this._TemplateRef_28_5);
    this._text_29 = this.renderer.createText(this._el_15,'\n                  ',(null as any));
    this._text_30 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._text_31 = this.renderer.createText(this._el_0,'\n              ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_9,'keyup',this.eventHandler(this._handle_keyup_9_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_9,'input',this.eventHandler(this._handle_input_9_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_9,'blur',this.eventHandler(this._handle_blur_9_2.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_20,'keyup',this.eventHandler(this._handle_keyup_20_0.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_20,'input',this.eventHandler(this._handle_input_20_1.bind(this)));
    var disposable_5:Function = this.renderer.listen(this._el_20,'blur',this.eventHandler(this._handle_blur_20_2.bind(this)));
    var disposable_6:Function = this.renderer.listen(this._el_26,'click',this.eventHandler(this._handle_click_26_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._el_26,
      this._text_27,
      this._anchor_28,
      this._text_29,
      this._text_30,
      this._text_31
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import45.DefaultValueAccessor) && (9 === requestNodeIndex))) { return this._DefaultValueAccessor_9_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (9 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_9_4; }
    if (((token === import42.FormControlName) && (9 === requestNodeIndex))) { return this._FormControlName_9_5.context; }
    if (((token === import43.NgControl) && (9 === requestNodeIndex))) { return this._NgControl_9_6; }
    if (((token === import44.NgControlStatus) && (9 === requestNodeIndex))) { return this._NgControlStatus_9_7.context; }
    if (((token === import54.SearchAutocompleteComponent) && ((11 <= requestNodeIndex) && (requestNodeIndex <= 12)))) { return this._SearchAutocompleteComponent_11_4.context; }
    if (((token === import45.DefaultValueAccessor) && (20 === requestNodeIndex))) { return this._DefaultValueAccessor_20_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (20 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_20_4; }
    if (((token === import42.FormControlName) && (20 === requestNodeIndex))) { return this._FormControlName_20_5.context; }
    if (((token === import43.NgControl) && (20 === requestNodeIndex))) { return this._NgControl_20_6; }
    if (((token === import44.NgControlStatus) && (20 === requestNodeIndex))) { return this._NgControlStatus_20_7.context; }
    if (((token === import54.SearchAutocompleteComponent) && ((22 <= requestNodeIndex) && (requestNodeIndex <= 23)))) { return this._SearchAutocompleteComponent_22_4.context; }
    if (((token === import25.TemplateRef) && (28 === requestNodeIndex))) { return this._TemplateRef_28_5; }
    if (((token === import27.NgIf) && (28 === requestNodeIndex))) { return this._NgIf_28_6.context; }
    if (((token === import47.FormGroupName) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 30)))) { return this._FormGroupName_2_3.context; }
    if (((token === import48.ControlContainer) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 30)))) { return this._ControlContainer_2_4; }
    if (((token === import44.NgControlStatusGroup) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 30)))) { return this._NgControlStatusGroup_2_5.context; }
    if (((token === import47.FormArrayName) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 31)))) { return this._FormArrayName_0_3.context; }
    if (((token === import48.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 31)))) { return this._ControlContainer_0_4; }
    if (((token === import44.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 31)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = 'soloists';
    this._FormArrayName_0_3.check_name(currVal_0_0_0,throwOnChange,false);
    this._FormArrayName_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    const currVal_2_0_0:any = this.context.index;
    this._FormGroupName_2_3.check_name(currVal_2_0_0,throwOnChange,false);
    this._FormGroupName_2_3.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this._NgControlStatusGroup_2_5.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this._DefaultValueAccessor_9_3.detectChangesInInputProps(this,this._el_9,throwOnChange);
    const currVal_9_1_0:any = 'name';
    this._FormControlName_9_5.check_name(currVal_9_1_0,throwOnChange,false);
    this._FormControlName_9_5.detectChangesInInputProps(this,this._el_9,throwOnChange);
    this._NgControlStatus_9_7.detectChangesInInputProps(this,this._el_9,throwOnChange);
    const currVal_11_0_0:any = this.parent.parent.parent.context.recordForm;
    this._SearchAutocompleteComponent_11_4.check_form(currVal_11_0_0,throwOnChange,false);
    const currVal_11_0_1:any = import5.interpolate(2,'music_pieces.',this.parent.context.index,'.soloists.',this.context.index,'.name');
    this._SearchAutocompleteComponent_11_4.check_formPath(currVal_11_0_1,throwOnChange,false);
    const currVal_11_0_2:any = import5.interpolate(2,'soloist',this.parent.context.index,'',this.context.index,'');
    this._SearchAutocompleteComponent_11_4.check_target(currVal_11_0_2,throwOnChange,false);
    const currVal_11_0_3:any = this.parent.parent.parent.context.inputFocus;
    this._SearchAutocompleteComponent_11_4.check_input(currVal_11_0_3,throwOnChange,false);
    const currVal_11_0_4:any = 'soloist';
    this._SearchAutocompleteComponent_11_4.check_esType(currVal_11_0_4,throwOnChange,false);
    this._SearchAutocompleteComponent_11_4.detectChangesInInputProps(this,this._el_11,throwOnChange);
    this._DefaultValueAccessor_20_3.detectChangesInInputProps(this,this._el_20,throwOnChange);
    const currVal_20_1_0:any = 'instrument';
    this._FormControlName_20_5.check_name(currVal_20_1_0,throwOnChange,false);
    this._FormControlName_20_5.detectChangesInInputProps(this,this._el_20,throwOnChange);
    this._NgControlStatus_20_7.detectChangesInInputProps(this,this._el_20,throwOnChange);
    const currVal_22_0_0:any = this.parent.parent.parent.context.recordForm;
    this._SearchAutocompleteComponent_22_4.check_form(currVal_22_0_0,throwOnChange,false);
    const currVal_22_0_1:any = import5.interpolate(2,'music_pieces.',this.parent.context.index,'.soloists.',this.context.index,'.instrument');
    this._SearchAutocompleteComponent_22_4.check_formPath(currVal_22_0_1,throwOnChange,false);
    const currVal_22_0_2:any = import5.interpolate(2,'instrument',this.parent.context.index,'',this.context.index,'');
    this._SearchAutocompleteComponent_22_4.check_target(currVal_22_0_2,throwOnChange,false);
    const currVal_22_0_3:any = this.parent.parent.parent.context.inputFocus;
    this._SearchAutocompleteComponent_22_4.check_input(currVal_22_0_3,throwOnChange,false);
    const currVal_22_0_4:any = 'instrument';
    this._SearchAutocompleteComponent_22_4.check_esType(currVal_22_0_4,throwOnChange,false);
    this._SearchAutocompleteComponent_22_4.detectChangesInInputProps(this,this._el_22,throwOnChange);
    const currVal_28_0_0:any = (this.context.index == (this.parent.parent.parent.context.recordForm.get('music_pieces').at(this.parent.context.index).get('soloists').controls.length - 1));
    this._NgIf_28_6.check_ngIf(currVal_28_0_0,throwOnChange,false);
    this._NgIf_28_6.detectChangesInInputProps(this,this._anchor_28,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._FormArrayName_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._FormGroupName_2_3.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this._NgControlStatusGroup_2_5.detectChangesInHostProps(this,this._el_2,throwOnChange);
    const currVal_55:any = import5.interpolate(2,'soloist',this.parent.context.index,'',this.context.index,'');
    if (import5.checkBinding(throwOnChange,this._expr_55,currVal_55)) {
      this.renderer.setElementProperty(this._el_9,'id',currVal_55);
      this._expr_55 = currVal_55;
    }
    this._DefaultValueAccessor_9_3.detectChangesInHostProps(this,this._el_9,throwOnChange);
    this._FormControlName_9_5.detectChangesInHostProps(this,this._el_9,throwOnChange);
    this._NgControlStatus_9_7.detectChangesInHostProps(this,this._el_9,throwOnChange);
    this._SearchAutocompleteComponent_11_4.detectChangesInHostProps(this,this._el_11,throwOnChange);
    const currVal_56:any = import5.interpolate(2,'instrument',this.parent.context.index,'',this.context.index,'');
    if (import5.checkBinding(throwOnChange,this._expr_56,currVal_56)) {
      this.renderer.setElementProperty(this._el_20,'id',currVal_56);
      this._expr_56 = currVal_56;
    }
    this._DefaultValueAccessor_20_3.detectChangesInHostProps(this,this._el_20,throwOnChange);
    this._FormControlName_20_5.detectChangesInHostProps(this,this._el_20,throwOnChange);
    this._NgControlStatus_20_7.detectChangesInHostProps(this,this._el_20,throwOnChange);
    this._SearchAutocompleteComponent_22_4.detectChangesInHostProps(this,this._el_22,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_9_5.context.ngOnDestroy();
    this._FormControlName_20_5.context.ngOnDestroy();
    this._FormArrayName_0_3.context.ngOnDestroy();
  }
  private _handle_keyup_9_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_9_0:any = ((<any>this.parent.parent.parent.context.onInputChange('soloist',$event)) !== false);
    return (true && pd_9_0);
  }
  private _handle_input_9_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_9_0:any = ((<any>this._DefaultValueAccessor_9_3.context.onChange($event.target.value)) !== false);
    return (true && pd_9_0);
  }
  private _handle_blur_9_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_9_0:any = ((<any>this._DefaultValueAccessor_9_3.context.onTouched()) !== false);
    return (true && pd_9_0);
  }
  private _handle_keyup_20_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_20_0:any = ((<any>this.parent.parent.parent.context.onInputChange('instrument',$event)) !== false);
    return (true && pd_20_0);
  }
  private _handle_input_20_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_20_0:any = ((<any>this._DefaultValueAccessor_20_3.context.onChange($event.target.value)) !== false);
    return (true && pd_20_0);
  }
  private _handle_blur_20_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_20_0:any = ((<any>this._DefaultValueAccessor_20_3.context.onTouched()) !== false);
    return (true && pd_20_0);
  }
  private _handle_click_26_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_26_0:any = ((<any>this.parent.parent.parent.context.onRemoveSoloist(this.parent.context.index,this.context.index)) !== false);
    return (true && pd_26_0);
  }
}
function viewFactory_ContentRecordEditComponent14(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent14(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent15 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent15,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_1 = import5.createRenderElement(this.renderer,this._el_0,'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-plus lLink'),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_1,'click',this.eventHandler(this._handle_click_1_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._el_1
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_1_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_1_0:any = ((<any>this.parent.parent.parent.parent.context.onAddSoloist(this.parent.parent.context.index)) !== false);
    return (true && pd_1_0);
  }
}
function viewFactory_ContentRecordEditComponent15(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent15(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent16 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _el_6:any;
  _text_7:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent16,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','input-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'S',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_6 = import5.createRenderElement(this.renderer,this._el_5,'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-plus lLink'),(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n              ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_6,'click',this.eventHandler(this._handle_click_6_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._el_6,
      this._text_7
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_6_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this.parent.parent.parent.context.onAddSoloist(this.parent.context.index)) !== false);
    return (true && pd_6_0);
  }
}
function viewFactory_ContentRecordEditComponent16(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent16(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent17 extends import1.AppView<any> {
  _el_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent17,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-plus lLink'),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.parent.context.onAddMusicPiece()) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentRecordEditComponent17(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent17(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent18 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  /*private*/ _appEl_5:import3.AppElement;
  _HtmlEditorComponent_5_4:import55.Wrapper_HtmlEditorComponent;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_10:any;
  _pipe_uppercase_1_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent18,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_10 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','form-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,' \n          ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'html-editor',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._appEl_5 = new import3.AppElement(5,0,this,this._el_5);
    var compView_5:any = import55.viewFactory_HtmlEditorComponent0(this.viewUtils,this.injector(5),this._appEl_5);
    this._HtmlEditorComponent_5_4 = new import55.Wrapper_HtmlEditorComponent();
    this._appEl_5.initComponent(this._HtmlEditorComponent_5_4.context,([] as any[]),compView_5);
    this._text_6 = this.renderer.createText((null as any),'\n          ',(null as any));
    compView_5.create(this._HtmlEditorComponent_5_4.context,([] as any[]),(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._pipe_uppercase_1_0 = import5.pureProxy1((<_View_ContentRecordEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentRecordEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'onEditorKeyup',this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
    const subscription_0:any = this._HtmlEditorComponent_5_4.context.onEditorKeyup.subscribe(this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import56.HtmlEditorComponent) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._HtmlEditorComponent_5_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    const currVal_5_0_0:any = ('editor-description-' + this.context.$implicit);
    this._HtmlEditorComponent_5_4.check_elementId(currVal_5_0_0,throwOnChange,false);
    const currVal_5_0_1:any = (this.parent.parent.context.content? this.parent.parent.context.content.description[this.context.$implicit]: '');
    this._HtmlEditorComponent_5_4.check_initText(currVal_5_0_1,throwOnChange,false);
    const currVal_5_0_2:any = 5;
    this._HtmlEditorComponent_5_4.check_height(currVal_5_0_2,throwOnChange,false);
    this._HtmlEditorComponent_5_4.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_10:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_0,(<_View_ContentRecordEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_10,currVal_10))) {
      this.renderer.setText(this._text_3,currVal_10);
      this._expr_10 = currVal_10;
    }
    this._HtmlEditorComponent_5_4.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._HtmlEditorComponent_5_4.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._HtmlEditorComponent_5_4.context.ngOnDestroy();
  }
  private _handle_onEditorKeyup_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.parent.context.keyupEditorHandlerFunction([
      'description',
      this.context.$implicit
    ]
    ,$event)) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentRecordEditComponent18(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent18(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent19 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _DefaultValueAccessor_2_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_2_4:any[];
  _FormControlName_2_5:import31.Wrapper_FormControlName;
  _NgControl_2_6:any;
  _NgControlStatus_2_7:import29.Wrapper_NgControlStatus;
  _text_3:any;
  _el_4:any;
  _el_5:any;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _appEl_7:import3.AppElement;
  _TemplateRef_7_5:any;
  _NgIf_7_6:import23.Wrapper_NgIf;
  _text_8:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent19,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray4(4,'class','input-group col-lg-3 col-md-4 col-sm-5','style','padding: 0px 3px 3px 0px; max-width: 200px'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'input',new import5.InlineArray4(4,'class','form-control','type','text'),(null as any));
    this._DefaultValueAccessor_2_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_2));
    this._NG_VALUE_ACCESSOR_2_4 = [this._DefaultValueAccessor_2_3.context];
    this._FormControlName_2_5 = new import31.Wrapper_FormControlName((<_View_ContentRecordEditComponent5>this.parent)._ControlContainer_134_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_2_4);
    this._NgControl_2_6 = this._FormControlName_2_5.context;
    this._NgControlStatus_2_7 = new import29.Wrapper_NgControlStatus(this._NgControl_2_6);
    this._text_3 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_4,'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-remove lLink'),(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_7 = new import3.AppElement(7,0,this,this._anchor_7);
    this._TemplateRef_7_5 = new import25.TemplateRef_(this._appEl_7,viewFactory_ContentRecordEditComponent20);
    this._NgIf_7_6 = new import23.Wrapper_NgIf(this._appEl_7.vcRef,this._TemplateRef_7_5);
    this._text_8 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'input',this.eventHandler(this._handle_input_2_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_2,'blur',this.eventHandler(this._handle_blur_2_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_5,'click',this.eventHandler(this._handle_click_5_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._el_5,
      this._text_6,
      this._anchor_7,
      this._text_8
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import45.DefaultValueAccessor) && (2 === requestNodeIndex))) { return this._DefaultValueAccessor_2_3.context; }
    if (((token === import41.NG_VALUE_ACCESSOR) && (2 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_2_4; }
    if (((token === import42.FormControlName) && (2 === requestNodeIndex))) { return this._FormControlName_2_5.context; }
    if (((token === import43.NgControl) && (2 === requestNodeIndex))) { return this._NgControl_2_6; }
    if (((token === import44.NgControlStatus) && (2 === requestNodeIndex))) { return this._NgControlStatus_2_7.context; }
    if (((token === import25.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import27.NgIf) && (7 === requestNodeIndex))) { return this._NgIf_7_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DefaultValueAccessor_2_3.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_2_1_0:any = import5.interpolate(1,'',this.context.index,'');
    this._FormControlName_2_5.check_name(currVal_2_1_0,throwOnChange,false);
    this._FormControlName_2_5.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this._NgControlStatus_2_7.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_7_0_0:any = (this.parent.parent.context.recordForm.controls.tags.controls.length == (this.context.index + 1));
    this._NgIf_7_6.check_ngIf(currVal_7_0_0,throwOnChange,false);
    this._NgIf_7_6.detectChangesInInputProps(this,this._anchor_7,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._DefaultValueAccessor_2_3.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this._FormControlName_2_5.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this._NgControlStatus_2_7.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_2_5.context.ngOnDestroy();
  }
  private _handle_input_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this._DefaultValueAccessor_2_3.context.onChange($event.target.value)) !== false);
    return (true && pd_2_0);
  }
  private _handle_blur_2_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this._DefaultValueAccessor_2_3.context.onTouched()) !== false);
    return (true && pd_2_0);
  }
  private _handle_click_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.parent.context.onRemoveTag(this.context.index)) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentRecordEditComponent19(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent19(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent20 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent20,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_1 = import5.createRenderElement(this.renderer,this._el_0,'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-plus lLink'),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_1,'click',this.eventHandler(this._handle_click_1_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._el_1
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_1_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_1_0:any = ((<any>this.parent.parent.parent.context.onAddTag()) !== false);
    return (true && pd_1_0);
  }
}
function viewFactory_ContentRecordEditComponent20(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent20(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordEditComponent21 extends import1.AppView<any> {
  _el_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordEditComponent21,renderType_ContentRecordEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-plus lLink'),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.parent.context.onAddTag()) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentRecordEditComponent21(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordEditComponent21(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-record-edit.component.ngfactory.ts